// eslint-disable
// This client has been automatically generated by @kempowersw/generate-rest-client@1.1.8
import { Injectable } from '@angular/core';
import { AuthTokenService } from '@kempowersw/ngx-auth-token-service';
import { HttpClient } from '@angular/common/http';
import {
    PostWarrantyHistoryRequest,
    PostWarrantyHistoryResponse,
    PutWarrantyHistoryRequest,
    WarrantyHistory,
    StationCommissioningStep,
} from '@kempoweroyj/ngx-charging-stations-api-client';

interface RequestOptions {
    headers?: { [key: string]: string };
}

@Injectable()
export class ChargingStationsApiService {
    constructor(
        private http: HttpClient,
        private authTokenService: AuthTokenService
    ) {}

    /** Returns a copy of the ChargingStations API client that uses the given JWT for authorization */
    withToken(jwt: string) {
        return new ChargingStationsApiService(this.http, { ...this.authTokenService, jwt });
    }

    /**
     * Get all tenant's charging stations
     */
    async getChargingStations(
        queryParams?: GetChargingStationsQueryParameters,
        options?: RequestOptions
    ): Promise<GetChargingStationsResponse> {
        return this.http
            .get<GetChargingStationsResponse>(
                `${this.authTokenService.restApiUrl}/chargingStations?${Object.keys(queryParams || {})
                    .reduce(
                        (acc, k) =>
                            queryParams[k] !== undefined ? [...acc, `${k}=${encodeURIComponent(queryParams[k])}`] : acc,
                        []
                    )
                    .join('&')}`,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Get information about a charging station
     */
    async getChargingStation(
        stationId: string,
        queryParams?: GetChargingStationQueryParameters,
        options?: RequestOptions
    ): Promise<GetChargingStationResponse> {
        return this.http
            .get<GetChargingStationResponse>(
                `${this.authTokenService.restApiUrl}/chargingStations/${encodeURIComponent(stationId)}?${Object.keys(
                    queryParams || {}
                )
                    .reduce(
                        (acc, k) =>
                            queryParams[k] !== undefined ? [...acc, `${k}=${encodeURIComponent(queryParams[k])}`] : acc,
                        []
                    )
                    .join('&')}`,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Create a new ChargingStation
     */
    async postChargingStation(
        body: PostChargingStationRequest,
        options?: RequestOptions
    ): Promise<PostChargingStationResponse> {
        return this.http
            .post<PostChargingStationResponse>(`${this.authTokenService.restApiUrl}/chargingStations`, body, {
                headers: {
                    Authorization: `Bearer ${this.authTokenService.jwt}`,
                    ...(options?.headers || {}),
                },
            })
            .toPromise();
    }

    /**
     * Updates an existing ChargingStation
     */
    async putChargingStation(
        stationId: string,
        body: PutChargingStationRequest,
        options?: RequestOptions
    ): Promise<PutChargingStationResponse> {
        return this.http
            .put<PutChargingStationResponse>(
                `${this.authTokenService.restApiUrl}/chargingStations/${encodeURIComponent(stationId)}`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Updates an existing ChargingStation tenants
     */
    async putChargingStationTenants(
        stationId: string,
        body: PutChargingStationTenantsRequest,
        options?: RequestOptions
    ): Promise<PutChargingStationTenantsResponse> {
        return this.http
            .put<PutChargingStationTenantsResponse>(
                `${this.authTokenService.restApiUrl}/chargingStations/${encodeURIComponent(stationId)}/tenants`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Get charging station tenants
     */
    async getChargingStationTenants(
        stationId: string,
        options?: RequestOptions
    ): Promise<GetChargingStationTenantsResponse> {
        return this.http
            .get<GetChargingStationTenantsResponse>(
                `${this.authTokenService.restApiUrl}/chargingStations/${encodeURIComponent(stationId)}/tenants`,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Deletes a ChargingStation
     */
    async deleteChargingStation(stationId: string, options?: RequestOptions): Promise<DeleteChargingStationResponse> {
        return this.http
            .delete<DeleteChargingStationResponse>(
                `${this.authTokenService.restApiUrl}/chargingStations/${encodeURIComponent(stationId)}`,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Fetch a list of all charging stations
     */
    async getStations(options?: RequestOptions): Promise<GetStationsResponse> {
        return this.http
            .get<GetStationsResponse>(`${this.authTokenService.restApiUrl}/stations`, {
                headers: {
                    Authorization: `Bearer ${this.authTokenService.jwt}`,
                    ...(options?.headers || {}),
                },
            })
            .toPromise();
    }

    /**
     * Fetch information of a single charging station
     */
    async getStation(stationId: string, options?: RequestOptions): Promise<GetStationResponse> {
        return this.http
            .get<GetStationResponse>(`${this.authTokenService.restApiUrl}/stations/${encodeURIComponent(stationId)}`, {
                headers: {
                    Authorization: `Bearer ${this.authTokenService.jwt}`,
                    ...(options?.headers || {}),
                },
            })
            .toPromise();
    }

    /**
     * Post new attachments for a station
     */
    async postChargingStationAttachments(
        stationId: string,
        body: PostChargingStationAttachmentsRequest,
        options?: RequestOptions
    ): Promise<PostChargingStationAttachmentsResponse> {
        return this.http
            .post<PostChargingStationAttachmentsResponse>(
                `${this.authTokenService.restApiUrl}/stations/${encodeURIComponent(stationId)}/attachments`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Get attachments for a station
     */
    async getChargingStationAttachments(
        stationId: string,
        options?: RequestOptions
    ): Promise<GetChargingStationAttachmentsResponse> {
        return this.http
            .get<GetChargingStationAttachmentsResponse>(
                `${this.authTokenService.restApiUrl}/stations/${encodeURIComponent(stationId)}/attachments`,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Delete an attachment from a station
     */
    async deleteChargingStationAttachment(
        stationId: string,
        fileKey: string,
        options?: RequestOptions
    ): Promise<DeleteChargingStationAttachmentResponse> {
        return this.http
            .delete<DeleteChargingStationAttachmentResponse>(
                `${this.authTokenService.restApiUrl}/stations/${encodeURIComponent(stationId)}/attachments/${encodeURIComponent(fileKey)}`,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Get inventory for a station
     */
    async getStationInventory(stationId: string, options?: RequestOptions): Promise<GetStationInventoryResponse> {
        return this.http
            .get<GetStationInventoryResponse>(
                `${this.authTokenService.restApiUrl}/stations/${encodeURIComponent(stationId)}/inventory`,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * PUT inventory for a station
     */
    async putStationInventory(
        stationId: string,
        body: PutStationInventoryRequest,
        options?: RequestOptions
    ): Promise<PutStationInventoryResponse> {
        return this.http
            .put<PutStationInventoryResponse>(
                `${this.authTokenService.restApiUrl}/stations/${encodeURIComponent(stationId)}/inventory`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Get commissioning for a station
     */
    async getStationCommissioning(
        stationId: string,
        options?: RequestOptions
    ): Promise<GetStationCommissioningResponse> {
        return this.http
            .get<GetStationCommissioningResponse>(
                `${this.authTokenService.restApiUrl}/stations/${encodeURIComponent(stationId)}/commissioning`,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * PUT commissioning for a station or create if not exist
     */
    async patchStationCommissioning(
        stationId: string,
        body: PatchStationCommissioningRequest,
        options?: RequestOptions
    ): Promise<PatchStationCommissioningResponse> {
        return this.http
            .patch<PatchStationCommissioningResponse>(
                `${this.authTokenService.restApiUrl}/stations/${encodeURIComponent(stationId)}/commissioning`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Station compability check for adaptive voltage
     */
    async getAdaptiveVoltageCompatibility(stationId: string, options?: RequestOptions): Promise<any> {
        return this.http
            .get<any>(
                `${this.authTokenService.restApiUrl}/chargingStations/${encodeURIComponent(stationId)}/adaptiveVoltageCompatibility`,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Create a new Warranty History entry for ChargingStation
     */
    async postWarrantyHistory(
        stationId: string,
        body: PostWarrantyHistoryRequest,
        options?: RequestOptions
    ): Promise<PostWarrantyHistoryResponse> {
        return this.http
            .post<PostWarrantyHistoryResponse>(
                `${this.authTokenService.restApiUrl}/chargingStations/${encodeURIComponent(stationId)}/warranty`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Get Warranty History for ChargingStation
     */
    async getWarrantyHistory(stationId: string, options?: RequestOptions): Promise<GetWarrantyHistoryResponse> {
        return this.http
            .get<GetWarrantyHistoryResponse>(
                `${this.authTokenService.restApiUrl}/chargingStations/${encodeURIComponent(stationId)}/warranty`,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Edit existing Warranty History entry
     */
    async putWarrantyHistory(
        stationId: string,
        expiryDate: string,
        body: PutWarrantyHistoryRequest,
        options?: RequestOptions
    ): Promise<PutWarrantyHistoryResponse> {
        return this.http
            .put<PutWarrantyHistoryResponse>(
                `${this.authTokenService.restApiUrl}/chargingStations/${encodeURIComponent(stationId)}/warranty/${encodeURIComponent(expiryDate)}`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }

    /**
     * Deletes Warranty History entry
     */
    async deleteWarrantyHistory(
        stationId: string,
        expiryDate: string,
        options?: RequestOptions
    ): Promise<DeleteWarrantyHistoryResponse> {
        return this.http
            .delete<DeleteWarrantyHistoryResponse>(
                `${this.authTokenService.restApiUrl}/chargingStations/${encodeURIComponent(stationId)}/warranty/${encodeURIComponent(expiryDate)}`,
                {
                    headers: {
                        Authorization: `Bearer ${this.authTokenService.jwt}`,
                        ...(options?.headers || {}),
                    },
                }
            )
            .toPromise();
    }
}

export interface Alert {
    /**
     * Override Maximum power value in charger UI when Adaptive voltage is not shown.
     */
    ConnectorMaxPowerDisplay?: number;
    /**
     * Override 400V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay400V?: number;
    /**
     * Override 800V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay800V?: number;
    /**
     * Config - Static text to display instead of the Maximum power in kW (e.g. 40 kW)
     */
    MaxPowerDisplay?: string;
    /**
     * Config -Short additional text to display on the charger
     */
    SupplementaryNote?: string;
    /**
     * Actual EVSE identifier - that is, EVSE as in can output to one EV at a time.
     * If multiple "chargeye evses" share this same evseNumber then they belong to the same EVSE.
     * This can be the case for e.g. X-satellites or some Trolleys configured as Sequential.
     * In 3rd party chargers this will be the evse uid.
     */
    actualEVSEId?: string | number;
    /**
     * ChargingPriority for this connector (-9 ... 9 as of OSCP2.0.1 in 1.60.2. TransactionEventResponse)
     */
    chargingPriority?: number | null;
    /**
     * Used to deduce whether or not the evse is currently in active configuration
     */
    configurationId?: number;
    /**
     * If true, this alert has been "dismissed" and hidden from view
     */
    dismissed?: boolean;
    /**
     * when this notification was dismissed
     */
    dismissedTimestamp?: string;
    /**
     * user who dismissed this notification
     */
    dismissedUserId?: string;
    /**
     * ID of energy meter, if known.
     */
    eMeterId?: string | null;
    /**
     * True if energy meter is available for this connector.
     */
    eMeterPresent?: boolean | null;
    /**
     * Public key of energy meter, if known.
     */
    eMeterPublicKey?: string | null;
    /**
     * end timestamp for this alert
     */
    endTime?: string;
    /**
     * Error code
     */
    errorCode?: string;
    /**
     * EVSE unique identifier.
     */
    evseId: string;
    /**
     * Name of the evse/connector
     */
    evseName?: string;
    /**
     * Type of the evse/connector
     */
    evseType?: 'AC' | 'CCS' | 'CHAdeMO' | 'Type2' | 'oppcharge';
    groupPath?: string | null;
    /**
     * synthetic alert id
     */
    id?: string;
    /**
     * Connector Geo latitude
     */
    lat?: number;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    liquidCoolingSystem?: {
        /**
         * Coolant level sensor error.
         */
        coolantLevelSensorError: boolean;
        /**
         * Status of cable temperatures and contact temperatures.
         */
        dcTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Are fans set to on state.
         */
        fansOn: boolean;
        /**
         * Status of LC system housing temperature.
         */
        housingTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Status of leakage detection.
         */
        leakageDetectionStatus?: 'Error' | 'Init' | 'LeakageDetected' | 'Triggered' | 'WaitingForTrigger';
        /**
         * Status of leakage sensor.
         */
        leakageSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Overall status of liquid cooled system.
         */
        overallStatus: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Is lc connector pluggedin.
         */
        pluggedInDetectionStatus?: {
            /**
             * Status of connector latch
             */
            PPSignalLatchStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * Connector plugin status
             */
            PPSignalPlugStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * PP signal status.
             * PP-Signal state describes, if the HPC is plugged into a car‘s inlet and if the latch (HPC Type 1) is pressed
             */
            PPSignalStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        };
        /**
         * Are pumps set to on state.
         */
        pumpOn: boolean;
        /**
         * Status of shock sensor.
         */
        shockSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * System info of liquid cooled system.
         */
        systemInfo: {
            /**
             * Hardware version LC system.
             */
            HWVer?: string;
            /**
             * Software version LC system.
             */
            SWVer?: string;
            /**
             * Type of the liquid cooled cable. For example: 'phoenix-liquid-cooled-cable'
             */
            type: string;
        };
        /**
         * Current values of temperature sensors.
         */
        temperatures: {
            /**
             * Temperature of the lc satellite housing.
             */
            housingTemp?: number;
            /**
             * Negative DC cable temperature.
             */
            negCableTemp?: number;
            /**
             * Negative DC Contact temperature.
             */
            negContactTemp: number;
            /**
             * Positive DC cable temperature.
             */
            posCableTemp?: number;
            /**
             * Positive DC Contact temperature.
             */
            posContactTemp: number;
        };
        /**
         * Timestamp of when the status was updated.
         */
        timestamp: string;
    } | null;
    /**
     * Connector Geo longitude
     */
    lng?: number;
    /**
     * Location this EVSE lies in
     */
    locationUid?: string;
    /**
     * Max connector cable current, e.g. 100 or 125 A
     */
    maxCableCurrent?: number;
    /**
     * Maximum power in kilowatts that this connector could output
     */
    maxPowerKw?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed
     */
    maxPowerKwWithoutDynamicLimit?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed (unrounded figure)
     */
    maxPowerKwWithoutDynamicLimitActual?: number;
    /**
     * Maximum power in kilowatts that this connector could output (unrounded figure)
     */
    maxPowerkWActual?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics)
     */
    maxPowerkWPresent?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics) (unrounded figure)
     */
    maxPowerkWPresentActual?: number;
    /**
     * Maximum voltage this EVSE can output (500 or 800V)
     */
    maxVoltage?: number;
    /**
     * Error message, or other details
     */
    message?: string;
    payload?: {
        [k: string]: any;
    } | null;
    /**
     * Station unique identifier.
     */
    stationId: string;
    tariffIds?: string[] | null;
    /**
     * When alert became active.
     * e.g. 2019-04-10T06:10:23.234Z
     */
    timestamp: string;
    /**
     * error message title
     */
    title?: string;
    /**
     * Type/code of the alert
     */
    type: string;
}

export interface AlertRow {
    /**
     * Override Maximum power value in charger UI when Adaptive voltage is not shown.
     */
    ConnectorMaxPowerDisplay?: number;
    /**
     * Override 400V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay400V?: number;
    /**
     * Override 800V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay800V?: number;
    /**
     * Config - Static text to display instead of the Maximum power in kW (e.g. 40 kW)
     */
    MaxPowerDisplay?: string;
    /**
     * Config -Short additional text to display on the charger
     */
    SupplementaryNote?: string;
    _gsi1pk: string;
    _gsi1sk: string;
    _gsi2pk: string;
    _gsi2sk: string;
    _gsiTenantCPOPk: string;
    _gsiTenantCPOSk: string;
    _gsiTenantEMSPPk: string;
    _gsiTenantEMSPSk: string;
    _gsiTenantMaintenancePk: string;
    _gsiTenantMaintenanceSk: string;
    _pk: string;
    _sk: string;
    /**
     * DynamoDB TTL (Time to Live) - item expiry time (unix timestamp).
     * Set for scheduled deletion of item row.
     * Please note this is SECONDS (unix timestamp) not MILLISECONDS (like usually in javascript).
     */
    _ttl?: number;
    /**
     * Actual EVSE identifier - that is, EVSE as in can output to one EV at a time.
     * If multiple "chargeye evses" share this same evseNumber then they belong to the same EVSE.
     * This can be the case for e.g. X-satellites or some Trolleys configured as Sequential.
     * In 3rd party chargers this will be the evse uid.
     */
    actualEVSEId?: string | number;
    /**
     * ChargingPriority for this connector (-9 ... 9 as of OSCP2.0.1 in 1.60.2. TransactionEventResponse)
     */
    chargingPriority?: number | null;
    /**
     * Used to deduce whether or not the evse is currently in active configuration
     */
    configurationId?: number;
    deleted?: boolean;
    /**
     * If true, this alert has been "dismissed" and hidden from view
     */
    dismissed?: boolean;
    /**
     * when this notification was dismissed
     */
    dismissedTimestamp?: string;
    /**
     * user who dismissed this notification
     */
    dismissedUserId?: string;
    /**
     * ID of energy meter, if known.
     */
    eMeterId?: string | null;
    /**
     * True if energy meter is available for this connector.
     */
    eMeterPresent?: boolean | null;
    /**
     * Public key of energy meter, if known.
     */
    eMeterPublicKey?: string | null;
    /**
     * end timestamp for this alert
     */
    endTime?: string;
    /**
     * Error code
     */
    errorCode?: string;
    /**
     * EVSE unique identifier.
     */
    evseId: string;
    /**
     * Name of the evse/connector
     */
    evseName?: string;
    /**
     * Type of the evse/connector
     */
    evseType?: 'AC' | 'CCS' | 'CHAdeMO' | 'Type2' | 'oppcharge';
    groupPath?: string | null;
    /**
     * synthetic alert id
     */
    id?: string;
    /**
     * Connector Geo latitude
     */
    lat?: number;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    liquidCoolingSystem?: {
        /**
         * Coolant level sensor error.
         */
        coolantLevelSensorError: boolean;
        /**
         * Status of cable temperatures and contact temperatures.
         */
        dcTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Are fans set to on state.
         */
        fansOn: boolean;
        /**
         * Status of LC system housing temperature.
         */
        housingTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Status of leakage detection.
         */
        leakageDetectionStatus?: 'Error' | 'Init' | 'LeakageDetected' | 'Triggered' | 'WaitingForTrigger';
        /**
         * Status of leakage sensor.
         */
        leakageSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Overall status of liquid cooled system.
         */
        overallStatus: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Is lc connector pluggedin.
         */
        pluggedInDetectionStatus?: {
            /**
             * Status of connector latch
             */
            PPSignalLatchStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * Connector plugin status
             */
            PPSignalPlugStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * PP signal status.
             * PP-Signal state describes, if the HPC is plugged into a car‘s inlet and if the latch (HPC Type 1) is pressed
             */
            PPSignalStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        };
        /**
         * Are pumps set to on state.
         */
        pumpOn: boolean;
        /**
         * Status of shock sensor.
         */
        shockSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * System info of liquid cooled system.
         */
        systemInfo: {
            /**
             * Hardware version LC system.
             */
            HWVer?: string;
            /**
             * Software version LC system.
             */
            SWVer?: string;
            /**
             * Type of the liquid cooled cable. For example: 'phoenix-liquid-cooled-cable'
             */
            type: string;
        };
        /**
         * Current values of temperature sensors.
         */
        temperatures: {
            /**
             * Temperature of the lc satellite housing.
             */
            housingTemp?: number;
            /**
             * Negative DC cable temperature.
             */
            negCableTemp?: number;
            /**
             * Negative DC Contact temperature.
             */
            negContactTemp: number;
            /**
             * Positive DC cable temperature.
             */
            posCableTemp?: number;
            /**
             * Positive DC Contact temperature.
             */
            posContactTemp: number;
        };
        /**
         * Timestamp of when the status was updated.
         */
        timestamp: string;
    } | null;
    /**
     * Connector Geo longitude
     */
    lng?: number;
    /**
     * Location this EVSE lies in
     */
    locationUid?: string;
    /**
     * Max connector cable current, e.g. 100 or 125 A
     */
    maxCableCurrent?: number;
    /**
     * Maximum power in kilowatts that this connector could output
     */
    maxPowerKw?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed
     */
    maxPowerKwWithoutDynamicLimit?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed (unrounded figure)
     */
    maxPowerKwWithoutDynamicLimitActual?: number;
    /**
     * Maximum power in kilowatts that this connector could output (unrounded figure)
     */
    maxPowerkWActual?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics)
     */
    maxPowerkWPresent?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics) (unrounded figure)
     */
    maxPowerkWPresentActual?: number;
    /**
     * Maximum voltage this EVSE can output (500 or 800V)
     */
    maxVoltage?: number;
    /**
     * Error message, or other details
     */
    message?: string;
    payload?: {
        [k: string]: any;
    } | null;
    schema: 'alert';
    schemaVersion?: number;
    /**
     * Station unique identifier.
     */
    stationId: string;
    tariffIds?: string[] | null;
    tenantIdCPO: string;
    tenantIdEMSP: string;
    tenantIdMaintenance: string;
    /**
     * Which tenants has access to this row
     */
    tenantIds: string[];
    /**
     * When alert became active.
     * e.g. 2019-04-10T06:10:23.234Z
     */
    timestamp: string;
    /**
     * error message title
     */
    title?: string;
    /**
     * Type/code of the alert
     */
    type: string;
    versionCreatedTenantId: string;
    versionCreatedTimestamp: string;
    versionCreatedUserId: string;
    versionCreatedUserRole: string;
    versionDeletedTimestamp?: string;
    versionDeletedUserId: string;
    versionModifiedTimestamp: string;
    versionModifiedUserId: string;
}

/**
 * Charger configuration options. Follows largely OCPP2.0.1 terminology.
 */
export interface BaseConfiguration {
    /**
     * Logical Component responsible for configuration relating to the reporting of clock-aligned meter data.
     */
    AlignedDataCtrlr?: {
        /**
         * If this variable reports a value of true, Aligned Data is enabled.
         */
        Enabled: boolean;
        /**
         * Size (in seconds) of the clock-aligned data interval, intended to be transmitted in the MeterValuesRequest message.
         */
        Interval: number;
        /**
         * Clock-aligned measurand(s) to be included in MeterValuesRequest, every AlignedDataInterval seconds.
         */
        Measurands?: string | null;
        /**
         * Sampled measurands to be included in the meterValues element of TransactionEventRequest (eventType =
         * Ended), every SampledDataTxEndedInterval seconds from the start of the transaction.
         */
        TxEndedMeasurands?: string | null;
        [k: string]: any;
    };
    /**
     * OCPP 2.0: Logical Component responsible for configuration relating to the use of a local cache for authorization for Charging Station use.
     */
    AuthCacheCtrlr?: {
        /**
         * If this variable exists, the Charging Station supports an Authorization Cache.
         */
        Enabled: boolean;
        /**
         * Indicates how long it takes until a token expires in the authorization cache since it is last used.
         *
         * Specifies how long (in seconds) after its last use until a token expires and is removed from the authorization cache.
         */
        LifeTime: number;
        [k: string]: any;
    };
    /**
     * OCPP 2.0: Logical Component responsible for configuration relating to the use of authorization for Charging Station use.
     */
    AuthCtrlr: {
        /**
         * If true, charger will allow anyone to stop charging, if session started remotely and network is offline. Since 1.2
         */
        AllowStopForRemoteStartedSessionsWhenOffline?: boolean;
        /**
         * Possible values are rfid, mobile, contract and evmac. Multiple values are separated by ,.
         * If empty, rfid and mobile authorization methods are in use.
         * If evmac is also given, the EV MAC address is attempted be used for authenticating the session.
         * EV MAC address is treated the same as an rfid tag, and verified automatically
         * using the local cache, local auth list, or by sending the Authorize request to backend.
         */
        AllowedAuthenticationMethods?: string;
        /**
         * If true, authorization is required to stop sessions which are Remote authorized. (CE, 3rd party backend)
         */
        AuthRequiredToStopRemoteStartedSessions?: boolean;
        /**
         * Kempower specific: If cable is plugged in first and charging is started, how long does user have to authorize before charging is stopped?
         */
        AuthorizationTimeOut?: number;
        /**
         * Whether a remote request to start a transaction in the form of RequestStartTransactionRequest message should be authorized beforehand like a local action to start a transaction.
         */
        AuthorizeRemoteStart?: boolean;
        /**
         * Allow user to stop charging from charger's panel if started with EV MAC authentication
         */
        EVMacAuthenticationAllowLocalStop?: boolean;
        /**
         * If true, do not send Authorize requests to backend to verify the EV.
         */
        EVMacAuthenticationLocalOnly?: boolean;
        /**
         * If true, and if EV is not authorized (or is not pre-authorized with an RFID tag), do stop the charging.
         */
        EVMacAuthenticationStopOnInvalid?: boolean;
        /**
         * If true, MAC address is sent to OCPP server in format "VID:112233AABBCC". If false, format is "11:22:33:AA:BB:CC".
         */
        EVMacAutoChargeCompliant?: boolean;
        /**
         * If this variable reports a value of true, Authorization is enabled.
         */
        Enabled: boolean;
        /**
         * If true, charger will allow charging without payment if network offline. Since 1.2
         */
        FreeVendingWhenOffline?: boolean;
        /**
         * Whether the Charging Station, when Offline, will start a transaction for locally-authorized identifiers.
         */
        LocalAuthorizeOffline?: boolean;
        /**
         * Whether the Charging Station, when online, will start a transaction for locally-authorized identifiers without waiting for or requesting an AuthorizeResponse from the CSMS.
         */
        LocalPreAuthorize?: boolean;
        /**
         * If this key exists, the Charging Station supports Unknown Offline Authorization.
         */
        OfflineTxForUnknownIdEnabled?: boolean;
        OverwriteTokenWithEvMacAddress?: boolean;
        /**
         * OCPP1.6 specific: If Auth not enabled ("free mode"), which tag should we use
         */
        TokenForUnauthenticated?: string | null;
        /**
         * If true, pressing the stop button on charger requires a second confirmation stop button press.
         */
        UserStopRequiresConfirm?: boolean;
        [k: string]: any;
    };
    ClockCtrlr?: {
        /**
         * The address of the NTP server used, such as `1.vendor.pool.ntp.org`
         */
        NtpServerUri?: string;
        /**
         * Source of NTP time. Either `manual` or `DHCP`
         */
        NtpSource?: 'DHCP' | 'manual';
        /**
         * Local time offset in the format: "+01:00", "-02:00" etc. Used for display purposes
         */
        TimeOffset?: string;
        [k: string]: any;
    };
    DemoModeCtrlr?: {
        /**
         * Forces the UI to show Adaptive Voltage interface. Uses the `ConnectorMaxPowerDisplay800V` and `ConnectorMaxPowerDisplay400V` values from `DisplayMessageCtrlr`
         */
        AdaptiveVoltageDemo?: boolean;
        /**
         * Automatically execute unplug command after short period of time once the charging has ended
         */
        AutoUnplugOnceDone?: boolean;
        /**
         * Disables all settings under this component if set to false
         */
        Enabled?: boolean;
        /**
         * Shows menu to control the EV simulator - not meant to be used for common demoing
         */
        ShowEvSimControlMenu?: boolean;
        [k: string]: any;
    };
    /**
     * Kempower-specific, panel settings
     */
    DisplayCtrlr: {
        /**
         * GIF or PNG as "data uri" (base64 encoded) displayed on the mobile phone - for customer customization. 97x152 - should begin with string "data:image/gif;base64,"
         */
        AppLogoBase64DataUri?: string | null;
        /**
         * Mobile app name, displayed on the panel together with the logo
         */
        AppName?: string | null;
        /**
         * List of languages that are visible and selectable in the user interface panel, e.g. fi,en,de,no. Comma separated list of values.
         */
        AvailableUiLanguages?: string | null;
        /**
         * Custom text for plugging in the cable
         */
        CustomCableInstruction?: string | null;
        /**
         * If stop confirmation is required (AuthCtrlr.UserStopRequiresConfirm), what message to display to the user?
         */
        CustomConfirmStopMsg?: string | null;
        /**
         * If stop confirmation is required (AuthCtrlr.UserStopRequiresConfirm), what message title to display to the user?
         */
        CustomConfirmStopTitle?: string | null;
        /**
         * URL of a custom view to be shown in the Charger panel
         */
        CustomViewURL?: string | null;
        /**
         * Sets the panel default language, possible values are language codes in ISO 639-1 format e.g. "fi", "en", "no" or "de". If not set the default value is "en"
         */
        DefaultUiLanguage?: string | null;
        DemoModeEnabled: boolean;
        /**
         * Dims screen when not in use if set to true
         */
        DimScreenWhenIdle?: boolean;
        /**
         * Message which should be displayed on the UI panel to users.
         */
        DisplayNote?: string | null;
        HideStopOnTouchSreen: boolean;
        /**
         * True to hide the "Charging station requires authentication" text and the "Authentication methods" list.
         */
        InfoHideAuthDescription?: boolean | null;
        /**
         * Display a QR code in the Info page with this content, usually a URL.
         */
        InfoQrCodeLink?: string | null;
        /**
         * Text visible in Info screen, e.g. Support contact
         */
        InfoText?: string | null;
        InvertConnectors: boolean;
        /**
         * If true, "Leave feedback" button will be visible in the mobile view
         */
        MobileLeaveFeedback?: boolean;
        /**
         * If true, charging failures show a "Leave feedback" link/qr code
         */
        MobileLeaveFeedbackOnFailure?: boolean;
        /**
         * Display QR code while charging
         */
        MobileQrCodeEnabled: boolean;
        MobileQrCodeLinkUrlPrefix?: string | null;
        /**
         * Show mobile QR code on ended view on the charger Panel
         */
        MobileQrOnEndedView: boolean;
        /**
         * Which layout is shown in panel. Possible values: layout1, layout2
         */
        PanelActiveLayout: string | null;
        /**
         * URL to a file describing charger user interface panel customizations.
         */
        PlaylistUrl?: string | null;
        PowerCalculationVoltageOverride?: ('400V' | '500V') | null;
        /**
         * Override Power Display on charger with serial connection capability
         * * `auto` Default - show power for both 400V and 800V if serial connectivity is possible.
         * * `400V` - show power only for 400V
         * * `800V` - show power only for 800V
         */
        PowerDisplayOverride?: '400V' | '800V' | 'auto';
        /**
         * Screen brightness. Number between 1 (min) and 7 (max)
         */
        ScreenBrightness?: number | null;
        SettingsEnabled: boolean;
        /**
         * Hides the (i) button on charging-view and shows all details always
         */
        ShowAdditionalChargingInfoAlways: boolean;
        /**
         * Show connector name as big instead of connector power
         */
        ShowConnectorNameAsBig?: boolean;
        ShowCustomerImageOnReadyScreen: boolean;
        /**
         * Show EN17186 standard icon in the panel Ready-view
         */
        ShowEN17186Icon: boolean;
        /**
         * Panel is allowed to display the CCS DC+/DC- pin temperatures (celsius) in the graph screen.
         */
        ShowPinTemperature?: boolean | null;
        /**
         * Show plug icon in the panel Ready-view
         */
        ShowPlugTypeIcon: boolean;
        /**
         * Show plug icon in the panel when preparing charging
         */
        ShowPlugTypeIconPreparing: boolean;
        /**
         * Show plug type text in the panel Ready-view (CCS2/CHAdeMO/etc)
         */
        ShowPlugTypeText: boolean;
        /**
         * If true, charger and mobile view will show if the EV or electricity grid is limiting the charging power
         */
        ShowPowerLimitation?: boolean;
        /**
         * Show Power Range (e.g 25-100 kW) Range is overridden with Supplementary text if supplementary text is set
         */
        ShowPowerRange: boolean;
        /**
         * Show state text (Available) in ready view
         */
        ShowStateInReadyView: boolean;
        /**
         * Shows systemInformation button always if set to true.
         *
         * **NOTE** This should not be enabled on a public charger
         */
        ShowSystemInformationBtnAlways?: boolean | null;
        /**
         * Panel is allowed to display the vehicle current demand/request in the graph screen.
         */
        ShowVehicleCurrentRequest?: boolean | null;
        /**
         * If true, display minimal details of the charging:
         * Do not display power (kW), charged energy (kWh), elapsed time, remaining time or SoC percentage, and disable the charging graph.
         */
        StealthMode?: boolean;
        UiMode: 'dark' | 'light';
        mileageForecast: boolean;
        percentageBlurEffect: boolean;
        targetBox: boolean;
        [k: string]: any;
    };
    DynamicsCtrlr?: {
        /**
         * If not enabled, dynamics config won't be controlled. This should always be enabled. Used for development purposes only.
         */
        Enabled?: boolean;
        /**
         * Dynamic power sharing mode - one of "Democratic", "ArrivalPriority" or "DepartureTimePriority". Defaults to Democratic.
         */
        Mode?: 'ArrivalPriority' | 'Democratic' | 'DepartureTimePriority';
        [k: string]: any;
    };
    /**
     * Communicates with an EV to exchange information and control charging using the ISO 15118 protocol.
     */
    ISO15118Ctrlr?: {
        /**
         * If enabled, charger will initiate certificate renewal process when there is at most
         * AutomaticRenewalOfSeccLeafCertificateDays days until certificate expiry.
         */
        AutomaticRenewalOfSeccLeafCertificate?: boolean;
        /**
         * Charger will initiate certificate renewal process when there is at most AutomaticRenewalOfSeccLeafCertificateDays days until certificate expiry.
         */
        AutomaticRenewalOfSeccLeafCertificateDays?: number;
        /**
         * If this variable exists and has the value true, then the Charge Point can provide a contract certificate that it cannot validate to the
         * Central System for validation as part of the Authorize.req.
         */
        CentralContractValidationAllowed?: boolean;
        /**
         * This configuration key can be used to configure the amount of times the Charge Point SHALL double the previous back-off time,
         * starting with the number of seconds configured at CertSigningWaitMinimum, every time the back-off time expires without having
         * received the CertificateSigned.req containing the signed certificate based on the CSR generated. When the maximum number of
         * increments is reached, the Charge Point SHALL stop resending the SignCertificate.req, until it is requested by the Central System
         * using a TriggerMessage.req.
         * Negative values must be rejected. The value 0 means that the Charge Point does not double the back-off time.
         */
        CertSigningRepeatTimes?: number;
        /**
         * This configuration key defines how long the Charge Point has to wait (in seconds) before generating another CSR, in the case the
         * Central System accepts the SignCertificate.req, but never returns the signed certificate back. This value will be doubled after every
         * attempt. The amount of attempts is configured at CertSigningRepeatTimes. If the certificate signing process is slow, this setting
         * allows the Central System to tell the Charge Point to allow more time.
         * Negative values must be rejected. The value 0 means that the Charge Point does not generate another CSR (leaving it up to the
         * Central System to trigger another certificate installation)
         */
        CertSigningWaitMinimum?: number;
        /**
         * If this variable is true, then the Charge Point will try to validate a contract certificate when it is offline
         */
        ContractValidationOffline?: boolean;
        /**
         * Does ChargEye or external partner handle the Plug&Charge related features
         */
        PncOperator?: 'chargeye' | 'external';
        /**
         * Common Name of the SECC (EVSE) leaf certificate.
         * The CN must be a SECCID: <Country Code>-<EVSE Operator ID>-<ID Type>-<ControllerID>-<Check Digit>
         * Example: DE-ICE-S-00003C4D557878675645330967543476-2
         * Type: string [39..255]
         */
        SeccLeafSubjectCommonName?: string;
        /**
         * Country of the SECC (EVSE) leaf certificate. Two letters that indicates in which country the CPO operates.
         * Example: DE
         * Type: string [2]
         */
        SeccLeafSubjectCountry?: string;
        /**
         * Organization of the SECC (EVSE) leaf certificate. Indicates which CPO operates this EVSE.
         * Example: Kempowers 3rd party customer Oy
         * Type: string [0..50]
         */
        SeccLeafSubjectOrganization?: string;
        /**
         * TLS in use
         * SeccLeaf* parameters must be provided
         */
        TlsEnabled?: boolean;
        [k: string]: any;
    };
    /**
     * OCPP 2.0: Logical Component responsible for configuration relating to the use of Local Authorization Lists for Charging Station use.
     */
    LocalAuthListCtrlr?: {
        /**
         * Whether Local Authorization List is enabled.
         */
        Enabled: boolean;
        [k: string]: any;
    };
    /**
     * Kempower-specific: Cloud log streaming settings
     */
    LoggingCtrlr: {
        Enabled: boolean;
        EnabledUntil?: string | null;
        [k: string]: any;
    };
    /**
     * Logical Component responsible for configuration relating to information exchange between Charging Station and CSMS.
     */
    OCPPCommCtrlr?: {
        /**
         * When a customer OCPP connection is active, perform a one-way hash of all idTokens before sending the info to Kempower cloud, so that the original id token cannot be recovered
         */
        HashExternalIdTokensSentToKempowerCloud: boolean;
        /**
         * Interval of inactivity (no OCPP exchanges) with CSMS after which the Charging Station should send HeartbeatRequest.
         */
        HeartbeatInterval: number;
        /**
         * How long the Charging Station should wait before resubmitting a TransactionEventRequest message that the CSMS failed to process.
         */
        MessageAttemptInterval: number;
        /**
         * How many times the Charging Station should try to submit a TransactionEventRequest message when the CSMS fails to process it
         */
        MessageAttempts: number;
        /**
         * If this variable set to true, then the Charge Point supports ISO 15118 plug and charge messages via the DataTransfer mechanism as
         * described in this application note.
         */
        OCPP16PnCEnabled?: boolean;
        /**
         * Number of times to retry a reset of the Charging Station when a reset was unsuccessful.
         */
        ResetRetries: number;
        /**
         * Sends a StatusNotification message with status `Preparing` once user selects a connector.
         */
        SendPreparingStatusOnceConnectorIsSelected?: boolean;
        /**
         * Whether to use sequential connector ids (1, 2, 3...) or ids for satellites like 11, 12, 21, 22, etc. Applies to OCPP16J only.
         */
        SequentialConnectorIdsEnabled: boolean;
        /**
         * (AC only) When set to true, the Charging Station SHALL unlock the cable on Charging Station side when the cable is unplugged at the EV.
         */
        UnlockOnEVSideDisconnect: boolean;
        /**
         * Number of seconds between pings.
         */
        WebSocketPingInterval: number;
        [k: string]: any;
    };
    /**
     * Kempower-specific power module settings
     */
    PmcCtrlr: {
        /**
         * Is automatic voltage detection in use or not
         */
        AutomaticInputVoltageDetection?: boolean;
        /**
         * Pmc phase to phase voltage.
         */
        InputVoltage?: number;
        /**
         * Maximum current per phase.
         */
        MaximumInputCurrent?: number;
        MaximumInputPowerChoices?: {
            current: number;
            label: string;
        }[];
        /**
         * Maximum phase voltage. @deprecated in 2.4
         */
        MaximumInputVoltage?: number;
        [k: string]: any;
    };
    ProxyCtrlr?: {
        /**
         * Whether Proxy is used for all charger communication or not. Disabling this setting will make other settings under ProxyCtrl non-functional
         */
        Enabled?: boolean;
        /**
         * Forces all network communication through a Socks5 proxy. Use format `socks5h://10.0.0.1:1080/`
         */
        ProxyUri?: string;
        [k: string]: any;
    };
    ReceiptCtrlr?: {
        /**
         * Disables all settings under this component if set to false
         */
        Enabled?: boolean;
        /**
         * Final URL for the receipt, supports templating; for example: `example.io/{{txId}}`
         */
        ReceiptUrl?: string;
        /**
         * Show "Show receipt"-button on mobile status
         */
        ShowReceiptOnMobileStatus?: boolean;
        [k: string]: any;
    };
    /**
     * Logical Component responsible for configuration relating to the reporting of sampled meter data.
     */
    SampledDataCtrlr?: {
        /**
         * If this variable reports a value of true, Sampled Data is enabled.
         */
        Enabled: boolean;
        /**
         * Sampled measurands to be included in the meterValues element of
         * TransactionEventRequest (eventType = Ended), every TxEndedSampleInterval seconds from
         * the start of the transaction.
         * Defaults to Energy.Active.Import.Register,SoC,Current.Import,Voltage,Power.Active.Import.
         */
        TxEndedMeasurands?: string | null;
        /**
         * Interval between sampling of metering (or other) data, intended to be transmitted via TransactionEventRequest (eventType = Updated) messages
         * A value of "0" (numeric zero), by convention, is to be interpreted to mean that no sampled data should be transmitted.
         */
        TxUpdatedInterval: number;
        /**
         * Sampled measurands to be included in the meterValues element of every
         * TransactionEventRequest (eventType = Updated), every SampledDataTxUpdatedInterval
         * seconds from the start of the transaction. Comma separated.
         * Defaults to Energy.Active.Import.Register,SoC,Current.Import,Voltage,Power.Active.Import.
         */
        TxUpdatedMeasurands?: string | null;
        [k: string]: any;
    };
    SlacRestartCtrlr?: {
        /**
         * Allow charging restart when cable connected (Bus depot mode)
         */
        Enabled: boolean;
        [k: string]: any;
    };
    TariffCostCtrlr: {
        /**
         * If set to true charging cost can be more than EmvPreAuthorizationCents allows
         * If set to false charging will stop when price will be equal or greater than EmvPreAuthorizationCents
         */
        AllowExceedingPreAuthorizationCents?: boolean;
        /**
         * Pre-authorization amount customer paying by card is asked to pay.
         * Independent on the currency, In cents (1/100th of the currency unit).
         * e.g. 500 = 5 EUR, 1000 = 10 GBP, 30000 = 300 NOK
         */
        EmvPreAuthorizationCents?: number;
        /**
         * What is done for the payment session on timeout.
         * * `void` - voids the payment, nothing is charged
         * * `commit` - commits the full payment reservation
         */
        EmvTimeoutAction?: 'commit' | 'void';
        /**
         * When the payment session will timeout
         */
        EmvTimeoutTimeS?: number;
        /**
         * Whether Tariffs are enabled
         */
        Enabled: boolean;
        /**
         * Minimum energy charged (in watt-hours) for the session to be considered valid and payable. Value between 0 and 1000.
         * If charged less than this amount, any card payment will be voided and customer will not be billed.
         * Set to zero to disable.
         * e.g. 100 Wh
         */
        MinChargedEnergyToApplyTariff?: number;
        /**
         * Minimum charging time (in seconds) for the session to be considered valid and payable. Value greater than 0.
         * If charged less than this duration, any card payment will be voided and customer will not be billed.
         * Set to zero to disable.
         * e.g. 10 s
         */
        MinChargingTimeToApplyTariff?: number;
        /**
         * Whether charging cost is visible in the panel or not
         */
        ShowChargingCostInPanel: boolean;
        /**
         * Whether tariffs are visible in the panel or not
         */
        ShowTariffsInPanel: boolean;
        [k: string]: any;
    };
    /**
     * Kempower-specific satellite/connector settings
     */
    TemperatureCtrlr?: {
        /**
         * Whether charging is allowed in scenario where other of the two temperature sensor reports irrational value (very small or very big, likely non-functional). By default it is allowed
         */
        AllowChargingWithOneInvalidPinTemperature?: boolean;
        /**
         * Temperature limit where charging gets forcibly stopped. Requires a liquid cooling unit. Range 0-120 Degrees Celsius. Default value: 120
         */
        CableTemperatureLimitToStopCharging?: number;
        /**
         * Temperature limit where charging power starts to derate to prevent cables from overheating. Requires a liquid cooling unit. Range 0-120 Degrees Celsius. Default value: 100
         */
        CableTemperatureToStartDerating?: number;
        /**
         * Temperature limit where charging gets forcibly stopped. Range 0-90 Degrees Celsius. Default value: 90
         */
        PinTemperatureLimitToStopCharging?: number;
        /**
         * Maximum update interval to temperature information. Shall that time get exceed, the charging will be stopped with an temperature error. Range 10-60 seconds. Default value: 13
         */
        TemperatureMaxUpdateIntervalS?: number;
        /**
         * The temperature point at which the coolant pump is forced to on. This prevents the coolant from freezing. Range from -25 to 50 Degrees Celsius. Default value: -25
         */
        TemperatureToForceStartLiquidPump?: number;
        /**
         * The temperature point at which the coolant fans are turned on. This setting should be higher value than `TemperatureToStopCoolantFans`. Requires a liquid cooling unit. Range 0-90 Degrees Celsius. Default value: 80
         */
        TemperatureToStartCoolantFans?: number;
        /**
         * The temperature point at which the coolant fans are turned off. This setting should be lower value than `TemperatureToStartCoolantFans`. Requires a liquid cooling unit. Range 0-90 Degrees Celsius. Default value: 60
         */
        TemperatureToStopCoolantFans?: number;
        [k: string]: any;
    };
    /**
     * Logical Component responsible for configuration relating to transaction characteristics and behaviour.
     */
    TxCtrlr?: {
        ActionOnEnergyMeterFailure?: ('DISABLE' | 'FALLBACK_PMC' | 'FREE_ENERGY') | null;
        /**
         * Interval from between "starting" of a transaction until incipient transaction is automatically
         * canceled, due to failure of EV driver to (correctly) insert the charging cable connector(s) into
         * the appropriate socket(s). The Charging Station SHALL go back to the original state,
         * probably: 'Available'. "Starting" might be the swiping of the RFID, pressing a start button, a
         * RequestStartTransactionRequest being received etc.
         */
        EVConnectionTimeOut: number;
        /**
         * (AC only)
         * When set to true, the Charging Station SHALL administratively stop the transaction when the cable is unplugged from the EV.
         * The Charging Cable is unplugged at the EV side. This is detected by the Charging Station. The
         * Charging Station stops the transaction and sends a TransactionEventRequest to the CSMS. The
         * Charging Cable, if locked and UnlockOnEvSideDisconnect = false, will remain locked at the
         * Charging Station until the EV Driver returns and presents his/hers IdToken. Otherwise it will
         * unlock the cable.
         */
        StopTxOnEVSideDisconnect: boolean;
        /**
         * whether the Charging Station will stop an ongoing transaction when it receives a non-Accepted authorization status in TransactionEventResponse for this transaction
         */
        StopTxOnInvalidId: boolean;
        /**
         * Whether the Charging Station will stop an ongoing transaction when it receives a non-Accepted authorization status in TransactionEventResponse for this transaction while authorization is disabled. This setting will override `StopTxOnInvalidId` if enabled
         */
        StopTxOnInvalidIdOnFreeVending?: boolean;
        [k: string]: any;
    };
    [k: string]: any;
}

export interface CablePinTemperatureMetrics {
    pin1: number;
    pin2: number;
}

export interface CeCommonLabel {
    tenantIds?: string[] | null;
    value: string;
}

export interface ChargingStation {
    classification?: {
        access?: 'PUBLIC' | 'PRIVATE';
    };
    tenantIds?: string[];
    commissioningRequired?: boolean | null;
    customer?: {
        id?: string;
        name?: string;
    };
    /**
     * ID a customer has given to this station
     */
    customerSuppliedId?: string;
    firmwareVersion?: string | null;
    groupPath?: string | null;
    labels?: CeCommonLabel[] | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    location?: {
        address?: string | null;
        id?: string;
        lat?: number | null;
        lng?: number | null;
        locationId?: string | null;
        name?: string | null;
        roamingPoolId?: string;
    } | null;
    locationUid?: string | null;
    /**
     * Factory filled-in information about the charger
     */
    manufacturingInfo?: {
        /**
         * Date when charger was shippped to customer
         */
        deliveryDate?: string | null;
        extraOrders?: string[] | null;
        /**
         * Kempower order number
         */
        orderNumber?: string | null;
        /**
         * Original customer id
         */
        partnerId?: string | null;
        /**
         * Original customer name
         */
        partnerName?: string | null;
        /**
         * Product code e.g. C502P240ND4
         */
        productId?: string;
        /**
         * e.g. Charging Power Unit 500V/300kW/D4
         */
        productName?: string;
        /**
         * Serial number when manufactured
         */
        serialNumber?: string;
        /**
         * e.g. Inventory
         */
        serialNumberStatus?: string | null;
        /**
         * e.g. DEMO
         */
        stock?: string | null;
    };
    /**
     * Charger maximum output power at any point in time in kilowatts. How much power it can output simultaneously to all its connectors.
     */
    maxPowerKw?: number;
    model?: string | null;
    name: string;
    notes?: string | null;
    operationalStatus?: ('IN_OPERATION' | 'NOT_IN_OPERATION' | 'OUT_OF_ORDER') | null;
    operator?: string | null;
    /**
     * Capabilities that the station supports as a comma separated list.
     * For example when station supports serial connectable power modules,
     * contents would be:
     * stationCapabilities = "SerialConnection,Xxx, ... ,Yyy"
     */
    stationCapabilities?: string | null;
    /**
     * Station unique identifier.
     */
    stationId: string;
    vendorName?: string | null;
}

export type ChargingStationStatus = 'Faulted' | 'Operative' | 'Unavailable';

export interface Connection {
    /**
     * Country code of the client, as detected from IP address (by CloudFront in the 'Cloudfront-Viewer-Country' header).
     * The value is a two-letter country code (ISO 3166-1 alpha 2), like US (for USA) or TW (for Taiwan).
     * See https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2 for a list of countries.
     */
    clientCountryCode?: string;
    /**
     * IP address of the client
     */
    clientIpAddress: string;
    /**
     * Time when connection was ended or disconnected in ISO8601 format.
     * e.g. 2019-04-10T06:10:23.234Z
     */
    connectionEndTime?: string;
    /**
     * Unique connection identifier.
     */
    connectionId: string;
    /**
     * Connection start time in ISO8601 format,
     * e.g. 2019-04-10T06:10:23.234Z
     */
    connectionStartTime: string;
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    /**
     * Ocpi connection profile id related to this connection;
     */
    ocpiConnectionProfileId?: string;
    /**
     * Station unique identifier.
     */
    stationId: string;
    /**
     * Connection type - direct to charger or another backend?
     * Defaults to ocpp
     */
    type?: 'ocpi' | 'ocpp';
    /**
     * Connection version based on standards
     */
    version?: 'ocpi2.2' | 'ocpp1.6j' | 'ocpp2-kempower';
}

export interface ConnectionRow {
    _gsi1pk: string;
    _gsi1sk: string;
    _gsi2pk: string;
    _gsi2sk: string;
    _gsiTenantCPOPk: string;
    _gsiTenantCPOSk: string;
    _gsiTenantEMSPPk: string;
    _gsiTenantEMSPSk: string;
    _gsiTenantMaintenancePk: string;
    _gsiTenantMaintenanceSk: string;
    _pk: string;
    _sk: string;
    /**
     * DynamoDB TTL (Time to Live) - item expiry time (unix timestamp).
     * Set for scheduled deletion of item row.
     * Please note this is SECONDS (unix timestamp) not MILLISECONDS (like usually in javascript).
     */
    _ttl?: number;
    /**
     * Country code of the client, as detected from IP address (by CloudFront in the 'Cloudfront-Viewer-Country' header).
     * The value is a two-letter country code (ISO 3166-1 alpha 2), like US (for USA) or TW (for Taiwan).
     * See https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2 for a list of countries.
     */
    clientCountryCode?: string;
    /**
     * IP address of the client
     */
    clientIpAddress: string;
    /**
     * Time when connection was ended or disconnected in ISO8601 format.
     * e.g. 2019-04-10T06:10:23.234Z
     */
    connectionEndTime?: string;
    /**
     * Unique connection identifier.
     */
    connectionId: string;
    /**
     * Connection start time in ISO8601 format,
     * e.g. 2019-04-10T06:10:23.234Z
     */
    connectionStartTime: string;
    deleted?: boolean;
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    /**
     * Ocpi connection profile id related to this connection;
     */
    ocpiConnectionProfileId?: string;
    schema: 'connection';
    schemaVersion?: number;
    /**
     * Station unique identifier.
     */
    stationId: string;
    tenantIdCPO: string;
    tenantIdEMSP: string;
    tenantIdMaintenance: string;
    /**
     * Which tenants has access to this row
     */
    tenantIds: string[];
    /**
     * Connection type - direct to charger or another backend?
     * Defaults to ocpp
     */
    type?: 'ocpi' | 'ocpp';
    /**
     * Connection version based on standards
     */
    version?: 'ocpi2.2' | 'ocpp1.6j' | 'ocpp2-kempower';
    versionCreatedTenantId: string;
    versionCreatedTimestamp: string;
    versionCreatedUserId: string;
    versionCreatedUserRole: string;
    versionDeletedTimestamp?: string;
    versionDeletedUserId: string;
    versionModifiedTimestamp: string;
    versionModifiedUserId: string;
}

export interface ConnectorInfo {
    connectorId: string;
    latestTransaction: TxInfo;
    maxPowerKw: number;
    maxPowerKwActual: number;
    name: string;
    status: EVSEStatus;
    type: EVSEType;
}

/**
 * parsed mpstat command output
 * 06:24:38     CPU    %usr   %nice    %sys %iowait    %irq   %soft  %steal  %guest  %gnice   %idle
 * 06:24:38     all    1.89    0.32    9.13    0.05    0.00    0.76    0.00    0.00    0.00   87.85
 */
export interface CpuMetrics {
    /**
     * Show the percentage of time that the CPU or CPUs were idle and the system did not have an outstanding disk I/O request.
     */
    idle: number;
    /**
     * Show the percentage of time that the CPU or CPUs were idle during which the system had an outstanding disk I/O request.
     */
    iowait: number;
    /**
     * Show the percentage of time spent by the CPU or CPUs to service interrupts.
     */
    irq: number;
    /**
     * Show the percentage of CPU utilization that occurred while executing at the user level with nice priority.
     */
    nice: number;
    /**
     * Show the percentage of time spent by the CPU or CPUs to service softirqs.
     * A softirq (software interrupt) is one of up to 32 enumerated software interrupts
     * which can run on multiple CPUs at once.
     */
    soft: number;
    /**
     * Show the percentage of CPU utilization that occurred while executing at the system level (kernel).
     * Note that this does not include the time spent servicing interrupts or softirqs.
     */
    sys: number;
    /**
     * Show the percentage of CPU utilization that occurred while executing at the user level (application).
     */
    usr: number;
}

export interface CsmsNode {
    alert?: CsmsNodeAlert;
    children?: CsmsNode[];
    data?: {
        alert?: AlertRow;
        compactExtras?: {
            authInUse?: boolean;
            labelValues: string[];
            settingsProfileName?: string;
        };
        connection?: ConnectionRow;
        devices?: DeviceRow[];
        evse?: EvseRow;
        evses?: EvseRow[];
        group?: GroupRow;
        metrics?: SystemMetricsRow[];
        station?: {
            _gsi1pk: string;
            _gsi1sk: string;
            _gsi2pk: string;
            _gsi2sk: string;
            _gsiTenantCPOPk: string;
            _gsiTenantCPOSk: string;
            _gsiTenantEMSPPk: string;
            _gsiTenantEMSPSk: string;
            _gsiTenantMaintenancePk: string;
            _gsiTenantMaintenanceSk: string;
            _pk: string;
            _sk: string;
            /**
             * DynamoDB TTL (Time to Live) - item expiry time (unix timestamp).
             * Set for scheduled deletion of item row.
             * Please note this is SECONDS (unix timestamp) not MILLISECONDS (like usually in javascript).
             */
            _ttl?: number;
            commissioningRequired?: boolean | null;
            customer?: {
                id?: string;
                name?: string;
            };
            /**
             * ID a customer has given to this station
             */
            customerSuppliedId?: string;
            deleted?: boolean;
            firmwareVersion?: string | null;
            groupPath?: string | null;
            labels?: CeCommonLabel[] | null;
            /**
             * licenseId to enforce permissions on this charger
             */
            licenseId?: string | null;
            /**
             * tenantId which provides / pays for the license
             */
            licenseTenantId?: string | null;
            location?: {
                address?: string | null;
                id?: string;
                lat?: number | null;
                lng?: number | null;
                locationId?: string | null;
                name?: string | null;
                roamingPoolId?: string;
            } | null;
            locationUid?: string | null;
            /**
             * Factory filled-in information about the charger
             */
            manufacturingInfo?: {
                /**
                 * Date when charger was shippped to customer
                 */
                deliveryDate?: string | null;
                extraOrders?: string[] | null;
                /**
                 * Kempower order number
                 */
                orderNumber?: string | null;
                /**
                 * Original customer id
                 */
                partnerId?: string | null;
                /**
                 * Original customer name
                 */
                partnerName?: string | null;
                /**
                 * Product code e.g. C502P240ND4
                 */
                productId?: string;
                /**
                 * e.g. Charging Power Unit 500V/300kW/D4
                 */
                productName?: string;
                /**
                 * Serial number when manufactured
                 */
                serialNumber?: string;
                /**
                 * e.g. Inventory
                 */
                serialNumberStatus?: string | null;
                /**
                 * e.g. DEMO
                 */
                stock?: string | null;
            };
            /**
             * Charger maximum output power at any point in time in kilowatts. How much power it can output simultaneously to all its connectors.
             */
            maxPowerKw?: number;
            model?: string | null;
            name: string;
            notes?: string | null;
            operationalStatus?: ('IN_OPERATION' | 'NOT_IN_OPERATION' | 'OUT_OF_ORDER') | null;
            operator?: string | null;
            schema: string;
            schemaVersion?: number;
            /**
             * Capabilities that the station supports as a comma separated list.
             * For example when station supports serial connectable power modules,
             * contents would be:
             * stationCapabilities = "SerialConnection,Xxx, ... ,Yyy"
             */
            stationCapabilities?: string | null;
            /**
             * Station unique identifier.
             */
            stationId: string;
            tenantIdCPO: string;
            tenantIdEMSP: string;
            tenantIdMaintenance: string;
            /**
             * Which tenants has access to this row
             */
            tenantIds: string[];
            vendorName?: string | null;
            versionCreatedTenantId: string;
            versionCreatedTimestamp: string;
            versionCreatedUserId: string;
            versionCreatedUserRole: string;
            versionDeletedTimestamp?: string;
            versionDeletedUserId: string;
            versionModifiedTimestamp: string;
            versionModifiedUserId: string;
        };
        status?: StatusRow;
    };
    id: string;
    name: string;
    serialNumber?: string;
    status?: CsmsNodeStatus;
    type: 'device' | 'evse' | 'group' | 'station';
}

export interface CsmsNodeAlert {
    /**
     * Error code
     */
    errorCode?: string;
    /**
     * Error message, or other details
     */
    message?: string;
    /**
     * When alert became active.
     * e.g. 2019-04-10T06:10:23.234Z
     */
    timestamp: string;
    /**
     * Type of the error (based on OCPP20, if possible), or NoError
     */
    type: string;
}

export interface CsmsNodeStatus {
    alert?: boolean;
    descendantHasAlert?: boolean;
    descendantHasWarning?: boolean;
    reason?: string;
    status?:
        | 'Available'
        | 'Charging'
        | 'Faulted'
        | 'Occupied'
        | 'Offline'
        | 'Operative'
        | 'Reserved'
        | 'Unavailable'
        | 'Unknown';
    statusDate?: string;
    warning?: boolean;
}

export interface DeleteChargingStationAttachmentResponse {
    success: boolean;
}

export interface DeleteChargingStationResponse {
    success: true;
}

export interface DeleteWarrantyHistoryResponse {
    success: true;
}

export interface Device {
    configurationId?: number;
    /**
     * Contains various details about the device
     */
    details?: OmegaDetails | PowerModuleDetails | PaymentTerminalDetails;
    /**
     * Device type
     */
    deviceTypeShort: DeviceTypeShort;
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    /**
     * Device model name (from manufacturer's ERP), e.g. KEMPOWER C-500 H1
     */
    modelName?: string;
    satelliteId?: number;
    /**
     * Serial number of the device, e.g. 2400768.
     */
    serialNumber: string;
    /**
     * If true, the charger has not reported on this device and it might be actually exist
     */
    stale?: boolean;
    /**
     * Station unique identifier.
     */
    stationId: string;
}

export interface DeviceRow {
    _gsi1pk: string;
    _gsi1sk: string;
    _gsi2pk: string;
    _gsi2sk: string;
    _gsiTenantCPOPk: string;
    _gsiTenantCPOSk: string;
    _gsiTenantEMSPPk: string;
    _gsiTenantEMSPSk: string;
    _gsiTenantMaintenancePk: string;
    _gsiTenantMaintenanceSk: string;
    _pk: string;
    _sk: string;
    /**
     * DynamoDB TTL (Time to Live) - item expiry time (unix timestamp).
     * Set for scheduled deletion of item row.
     * Please note this is SECONDS (unix timestamp) not MILLISECONDS (like usually in javascript).
     */
    _ttl?: number;
    configurationId?: number;
    deleted?: boolean;
    /**
     * Contains various details about the device
     */
    details?: OmegaDetails | PowerModuleDetails;
    /**
     * Device type
     */
    deviceTypeShort: DeviceTypeShort;
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    /**
     * Device model name (from manufacturer's ERP), e.g. KEMPOWER C-500 H1
     */
    modelName?: string;
    satelliteId?: number;
    /**
     * Row type device
     */
    schema: 'device';
    schemaVersion?: number;
    /**
     * Serial number of the device, e.g. 2400768.
     */
    serialNumber: string;
    /**
     * Station unique identifier.
     */
    stationId: string;
    tenantIdCPO: string;
    tenantIdEMSP: string;
    tenantIdMaintenance: string;
    /**
     * Which tenants has access to this row
     */
    tenantIds: string[];
    versionCreatedTenantId: string;
    versionCreatedTimestamp: string;
    versionCreatedUserId: string;
    versionCreatedUserRole: string;
    versionDeletedTimestamp?: string;
    versionDeletedUserId: string;
    versionModifiedTimestamp: string;
    versionModifiedUserId: string;
}

/**
 * cs = Controller system (Omega) - of Trolleys, or of main cabinet
 * sc = Secondary controller (Omega in Satellites, secondary cabinets)
 * pm = Power module
 * rfid = RFID card reader
 * ledc = LED controller
 * emv = Payment terminal, close-integrated
 * emv_cloud = Payment terminal, cloud-integrated
 */
export type DeviceTypeShort = 'cs' | 'ledc' | 'pm' | 'rfid' | 'sc' | 'emv' | 'emv_cloud';

export interface DiskMetrics {
    /**
     * Disk usage for /mnt/data partition
     */
    mntData: {
        /**
         * Size available in kilobytes
         */
        available: number;
        /**
         * Total size in kilobytes
         */
        size: number;
        /**
         * Size used in kilobytes
         */
        used: number;
    };
    /**
     * Disk usage for / partition
     */
    root: {
        /**
         * Size available in kilobytes
         */
        available: number;
        /**
         * Total size in kilobytes
         */
        size: number;
        /**
         * Size used in kilobytes
         */
        used: number;
    };
}

export type EVSEStatus = 'Available' | 'Charging' | 'Faulted' | 'Occupied' | 'Reserved' | 'Unavailable' | 'Unknown';

export type EVSEType = 'AC' | 'CCS' | 'CHAdeMO' | 'Type2' | 'oppcharge';

export interface EvseRow {
    /**
     * Override Maximum power value in charger UI when Adaptive voltage is not shown.
     */
    ConnectorMaxPowerDisplay?: number;
    /**
     * Override 400V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay400V?: number;
    /**
     * Override 800V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay800V?: number;
    /**
     * Config - Static text to display instead of the Maximum power in kW (e.g. 40 kW)
     */
    MaxPowerDisplay?: string;
    /**
     * Config -Short additional text to display on the charger
     */
    SupplementaryNote?: string;
    _gsi1pk: string;
    _gsi1sk: string;
    _gsi2pk: string;
    _gsi2sk: string;
    _gsiTenantCPOPk: string;
    _gsiTenantCPOSk: string;
    _gsiTenantEMSPPk: string;
    _gsiTenantEMSPSk: string;
    _gsiTenantMaintenancePk: string;
    _gsiTenantMaintenanceSk: string;
    _pk: string;
    _sk: string;
    /**
     * DynamoDB TTL (Time to Live) - item expiry time (unix timestamp).
     * Set for scheduled deletion of item row.
     * Please note this is SECONDS (unix timestamp) not MILLISECONDS (like usually in javascript).
     */
    _ttl?: number;
    /**
     * Actual EVSE identifier - that is, EVSE as in can output to one EV at a time.
     * If multiple "chargeye evses" share this same evseNumber then they belong to the same EVSE.
     * This can be the case for e.g. X-satellites or some Trolleys configured as Sequential.
     * In 3rd party chargers this will be the evse uid.
     */
    actualEVSEId?: string | number;
    /**
     * ChargingPriority for this connector (-9 ... 9 as of OSCP2.0.1 in 1.60.2. TransactionEventResponse)
     */
    chargingPriority?: number | null;
    /**
     * Used to deduce whether or not the evse is currently in active configuration
     */
    configurationId?: number;
    deleted?: boolean;
    /**
     * ID of energy meter, if known.
     */
    eMeterId?: string | null;
    /**
     * True if energy meter is available for this connector.
     */
    eMeterPresent?: boolean | null;
    /**
     * Public key of energy meter, if known.
     */
    eMeterPublicKey?: string | null;
    /**
     * EVSE unique identifier.
     */
    evseId: string;
    /**
     * Name of the evse/connector
     */
    evseName?: string;
    /**
     * Type of the evse/connector
     */
    evseType?: 'AC' | 'CCS' | 'CHAdeMO' | 'Type2' | 'oppcharge';
    groupPath?: string | null;
    /**
     * Connector Geo latitude
     */
    lat?: number;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    liquidCoolingSystem?: {
        /**
         * Coolant level sensor error.
         */
        coolantLevelSensorError: boolean;
        /**
         * Status of cable temperatures and contact temperatures.
         */
        dcTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Are fans set to on state.
         */
        fansOn: boolean;
        /**
         * Status of LC system housing temperature.
         */
        housingTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Status of leakage detection.
         */
        leakageDetectionStatus?: 'Error' | 'Init' | 'LeakageDetected' | 'Triggered' | 'WaitingForTrigger';
        /**
         * Status of leakage sensor.
         */
        leakageSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Overall status of liquid cooled system.
         */
        overallStatus: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Is lc connector pluggedin.
         */
        pluggedInDetectionStatus?: {
            /**
             * Status of connector latch
             */
            PPSignalLatchStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * Connector plugin status
             */
            PPSignalPlugStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * PP signal status.
             * PP-Signal state describes, if the HPC is plugged into a car‘s inlet and if the latch (HPC Type 1) is pressed
             */
            PPSignalStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        };
        /**
         * Are pumps set to on state.
         */
        pumpOn: boolean;
        /**
         * Status of shock sensor.
         */
        shockSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * System info of liquid cooled system.
         */
        systemInfo: {
            /**
             * Hardware version LC system.
             */
            HWVer?: string;
            /**
             * Software version LC system.
             */
            SWVer?: string;
            /**
             * Type of the liquid cooled cable. For example: 'phoenix-liquid-cooled-cable'
             */
            type: string;
        };
        /**
         * Current values of temperature sensors.
         */
        temperatures: {
            /**
             * Temperature of the lc satellite housing.
             */
            housingTemp?: number;
            /**
             * Negative DC cable temperature.
             */
            negCableTemp?: number;
            /**
             * Negative DC Contact temperature.
             */
            negContactTemp: number;
            /**
             * Positive DC cable temperature.
             */
            posCableTemp?: number;
            /**
             * Positive DC Contact temperature.
             */
            posContactTemp: number;
        };
        /**
         * Timestamp of when the status was updated.
         */
        timestamp: string;
    } | null;
    /**
     * Connector Geo longitude
     */
    lng?: number;
    /**
     * Location this EVSE lies in
     */
    locationUid?: string;
    /**
     * Max connector cable current, e.g. 100 or 125 A
     */
    maxCableCurrent?: number;
    /**
     * Maximum power in kilowatts that this connector could output
     */
    maxPowerKw?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed
     */
    maxPowerKwWithoutDynamicLimit?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed (unrounded figure)
     */
    maxPowerKwWithoutDynamicLimitActual?: number;
    /**
     * Maximum power in kilowatts that this connector could output (unrounded figure)
     */
    maxPowerkWActual?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics)
     */
    maxPowerkWPresent?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics) (unrounded figure)
     */
    maxPowerkWPresentActual?: number;
    /**
     * Maximum voltage this EVSE can output (500 or 800V)
     */
    maxVoltage?: number;
    schema: 'evse';
    schemaVersion?: number;
    /**
     * Station unique identifier.
     */
    stationId: string;
    tariffIds?: string[] | null;
    tenantIdCPO: string;
    tenantIdEMSP: string;
    tenantIdMaintenance: string;
    /**
     * Which tenants has access to this row
     */
    tenantIds: string[];
    versionCreatedTenantId: string;
    versionCreatedTimestamp: string;
    versionCreatedUserId: string;
    versionCreatedUserRole: string;
    versionDeletedTimestamp?: string;
    versionDeletedUserId: string;
    versionModifiedTimestamp: string;
    versionModifiedUserId: string;
}

export interface ExternalCloudConfiguration {
    enabled?: boolean | null;
    endpoint?: string | null;
    /**
     * By default the charge point identity is appended to the endpoint. For example:
     * `<endpoint>/<identity>`
     * by enabling this the identity won't be appended.
     *
     * This allows more customized endpoint to be used. For example endpoint with Charge point identity as query param:
     * `wss://example.io?cid=12345`
     */
    excludeIdentityFromEndpoint?: boolean | null;
    identity?: string | null;
    /**
     * Disable TLSv1.3?
     * Defaults to false - use TLSv1.3 if server supports it.
     * If set to true, at maximum TLS v1.2 is used.
     * Used to work around buggy servers.
     */
    noTLSv13?: boolean | null;
    ocppInterface?:
        | ('Wired0' | 'Wired1' | 'Wired2' | 'Wired3' | 'Wireless0' | 'Wireless1' | 'Wireless2' | 'Wireless3')
        | null;
    token?: string | null;
    /**
     * If true, all OCPP messages are logged to a file named 'ext-trace.csv' under data directory on the charger. Defaults to false.
     */
    tracing?: boolean | null;
}

export interface FsMetrics {
    /**
     * Size available in kilobytes
     */
    available: number;
    /**
     * Total size in kilobytes
     */
    size: number;
    /**
     * Size used in kilobytes
     */
    used: number;
}

export interface GetChargingStationAttachmentsResponse {
    attachments: StationAttachment[];
}

export interface GetChargingStationQueryParameters {
    stationTenants?: boolean;
}

export interface GetChargingStationResponse {
    alert?: Alert;
    connection?: Connection;
    devices?: Device[];
    integrationSettings?: IntegrationSettings;
    metrics?: SystemMetrics[];
    onlineStatus?: OcpiOnlineStatusChargeyeOnlineStatusOcppbridge20OnlineStatusChargerOcppOnlineStatus;
    settings?: Settings;
    station: ChargingStation;
    status?: Status;
    structure?: SystemStructure;
    powerGroupStation?: LBStation;
}

export interface LBStation {
    /**
     * Reserve at least this much power at all times
     */
    minPowerReservationKw?: number;
    /**
     * If charger is offline, assume used power is this
     */
    offlinePowerKw?: number;
    /**
     * Array of parent groupIds, empty if "root"
     */
    parentPath: string[];
    /**
     * Load balancing prioritizes power delivery to stations with higher priority first
     */
    priority?: number;
    stationId: string;
}
export interface OcpiOnlineStatusChargeyeOnlineStatusOcppbridge20OnlineStatusChargerOcppOnlineStatus {
    'charger-ocpp'?: OnlineStatus;
    chargeye?: OnlineStatus;
    ocpi?: OnlineStatus;
    ocppbridge20?: OnlineStatus;
}

export interface GetChargingStationTenantsResponse {
    tenantIdCPO?: string;
    tenantIdEMSP?: string;
    tenantIdMaintenance?: string;
}

export interface GetChargingStationsListResponse {
    tree: {
        alert?: CsmsNodeAlert;
        children?: CsmsNode[];
        data?: {
            alert?: AlertRow;
            compactExtras?: {
                authInUse?: boolean;
                labelValues: string[];
                settingsProfileName?: string;
            };
            connection?: ConnectionRow;
            devices?: DeviceRow[];
            evse?: EvseRow;
            evses?: EvseRow[];
            group?: GroupRow;
            metrics?: SystemMetricsRow[];
            station?: {
                _gsi1pk: string;
                _gsi1sk: string;
                _gsi2pk: string;
                _gsi2sk: string;
                _gsiTenantCPOPk: string;
                _gsiTenantCPOSk: string;
                _gsiTenantEMSPPk: string;
                _gsiTenantEMSPSk: string;
                _gsiTenantMaintenancePk: string;
                _gsiTenantMaintenanceSk: string;
                _pk: string;
                _sk: string;
                /**
                 * DynamoDB TTL (Time to Live) - item expiry time (unix timestamp).
                 * Set for scheduled deletion of item row.
                 * Please note this is SECONDS (unix timestamp) not MILLISECONDS (like usually in javascript).
                 */
                _ttl?: number;
                commissioningRequired?: boolean | null;
                customer?: {
                    id?: string;
                    name?: string;
                };
                /**
                 * ID a customer has given to this station
                 */
                customerSuppliedId?: string;
                deleted?: boolean;
                firmwareVersion?: string | null;
                groupPath?: string | null;
                labels?: CeCommonLabel[] | null;
                /**
                 * licenseId to enforce permissions on this charger
                 */
                licenseId?: string | null;
                /**
                 * tenantId which provides / pays for the license
                 */
                licenseTenantId?: string | null;
                location?: {
                    address?: string | null;
                    id?: string;
                    lat?: number | null;
                    lng?: number | null;
                    locationId?: string | null;
                    name?: string | null;
                    roamingPoolId?: string;
                } | null;
                locationUid?: string | null;
                /**
                 * Factory filled-in information about the charger
                 */
                manufacturingInfo?: {
                    /**
                     * Date when charger was shippped to customer
                     */
                    deliveryDate?: string | null;
                    extraOrders?: string[] | null;
                    /**
                     * Kempower order number
                     */
                    orderNumber?: string | null;
                    /**
                     * Original customer id
                     */
                    partnerId?: string | null;
                    /**
                     * Original customer name
                     */
                    partnerName?: string | null;
                    /**
                     * Product code e.g. C502P240ND4
                     */
                    productId?: string;
                    /**
                     * e.g. Charging Power Unit 500V/300kW/D4
                     */
                    productName?: string;
                    /**
                     * Serial number when manufactured
                     */
                    serialNumber?: string;
                    /**
                     * e.g. Inventory
                     */
                    serialNumberStatus?: string | null;
                    /**
                     * e.g. DEMO
                     */
                    stock?: string | null;
                };
                /**
                 * Charger maximum output power at any point in time in kilowatts. How much power it can output simultaneously to all its connectors.
                 */
                maxPowerKw?: number;
                model?: string | null;
                name: string;
                notes?: string | null;
                operationalStatus?: ('IN_OPERATION' | 'NOT_IN_OPERATION' | 'OUT_OF_ORDER') | null;
                operator?: string | null;
                schema: string;
                schemaVersion?: number;
                /**
                 * Capabilities that the station supports as a comma separated list.
                 * For example when station supports serial connectable power modules,
                 * contents would be:
                 * stationCapabilities = "SerialConnection,Xxx, ... ,Yyy"
                 */
                stationCapabilities?: string | null;
                /**
                 * Station unique identifier.
                 */
                stationId: string;
                tenantIdCPO: string;
                tenantIdEMSP: string;
                tenantIdMaintenance: string;
                /**
                 * Which tenants has access to this row
                 */
                tenantIds: string[];
                vendorName?: string | null;
                versionCreatedTenantId: string;
                versionCreatedTimestamp: string;
                versionCreatedUserId: string;
                versionCreatedUserRole: string;
                versionDeletedTimestamp?: string;
                versionDeletedUserId: string;
                versionModifiedTimestamp: string;
                versionModifiedUserId: string;
            };
            status?: StatusRow;
        };
        id: string;
        name: string;
        parentGroupPath: string[];
        serialNumber?: string;
        status?: CsmsNodeStatus;
        type: 'device' | 'evse' | 'group' | 'station';
    }[];
}

export interface GetChargingStationsQueryParameters {
    compact?: boolean;
    exclusiveStartKey?: any;
    limit?: number;
    mode: 'list' | 'tree';
}

export type GetChargingStationsResponse = GetChargingStationsTreeResponse | GetChargingStationsListResponse;

export interface GetChargingStationsTreeResponse {
    tree: CsmsNode[];
}

export interface GetStationAdaptiveVoltageCompatibilityRequest {
    stationId: string;
}

export interface GetStationAdaptiveVoltageCompatibilityResponse {
    devices: ResponseDevice[];
    firmware: {
        compatible: boolean;
        description?: string;
        version: string;
    };
}

export interface GetStationCommissioningResponse {
    commissioning?: StationCommissioning;
}

export interface GetStationInventoryResponse {
    inventory: StationInventoryEntry[];
    timestamp: string;
}

export interface GetStationResponse {
    /**
     * AC-DC conversion ratio
     */
    acDcPowerRatio?: number;
    connectors: ConnectorInfo[];
    /**
     * Current intake at present (amperes) of the station
     */
    currentPowerA?: number;
    /**
     * Current output power (kW) of the station
     */
    currentPowerKw?: number;
    labels?: CeCommonLabel[] | null;
    location: {
        address: string;
        lat: number;
        lng: number;
        name: string;
    };
    /**
     * Maximum input current (amperes) of the station
     * that it could theoretically take with current configuration.
     * Equals to PMC input supply current.
     * Dynamic limits (charging profiles) do not affect this.
     */
    maxPowerA?: number;
    /**
     * MAX output power (kW) of the station undefined if not known
     */
    maxPowerKw?: number;
    name: string;
    onlineStatus: 'Offline' | 'Online';
    /**
     * Path in powerGroup tree, 0th value is the id of root. This station does not belong to a power group if this is null/empty
     */
    powerGroupParentPath?: string[];
    /**
     * Capabilities that the station supports as a comma separated list.
     * For example when station supports serial connectable power modules,
     * contents would be:
     * stationCapabilities = "SerialConnection,Xxx, ... ,Yyy"
     */
    stationCapabilities?: string | null;
    stationId: string;
    status: ChargingStationStatus;
}

export interface GetStationsResponse {
    stations: StationInfo[];
}

export interface GetWarrantyHistoryResponse {
    history: WarrantyHistory[];
}

export interface GroupRow {
    _gsi1pk: string;
    _gsi1sk: string;
    _gsi2pk: string;
    _gsi2sk: string;
    _gsiTenantCPOPk: string;
    _gsiTenantCPOSk: string;
    _gsiTenantEMSPPk: string;
    _gsiTenantEMSPSk: string;
    _gsiTenantMaintenancePk: string;
    _gsiTenantMaintenanceSk: string;
    _pk: string;
    _sk: string;
    /**
     * DynamoDB TTL (Time to Live) - item expiry time (unix timestamp).
     * Set for scheduled deletion of item row.
     * Please note this is SECONDS (unix timestamp) not MILLISECONDS (like usually in javascript).
     */
    _ttl?: number;
    deleted?: boolean;
    groupId: string;
    groupPath?: string;
    groupPathInclusive: string;
    name: string;
    schema: 'group';
    schemaVersion?: number;
    tenantIdCPO: string;
    tenantIdEMSP: string;
    tenantIdMaintenance: string;
    /**
     * Which tenants has access to this row
     */
    tenantIds: string[];
    versionCreatedTenantId: string;
    versionCreatedTimestamp: string;
    versionCreatedUserId: string;
    versionCreatedUserRole: string;
    versionDeletedTimestamp?: string;
    versionDeletedUserId: string;
    versionModifiedTimestamp: string;
    versionModifiedUserId: string;
}

export interface IntegrationSettings {
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    /**
     * Collection of ids for the ocpi connection profiles
     */
    ocpiConnectionProfileIds: string[];
    /**
     * Station unique identifier.
     */
    stationId: string;
}

export interface LCCableTemperatureMetrics {
    cableTempDCNeg?: number;
    cableTempDCPos?: number;
}

export interface LCPinTemperatureMetrics {
    pinTempDCNeg?: number;
    pinTempDCPos?: number;
}

export type LCSystemActiveState = 'Disabled' | 'Off' | 'On' | 'Unknown';

export interface LCSystemCurrentTemperatures {
    /**
     * Temperature of the lc satellite housing.
     */
    housingTemp?: number;
    /**
     * Negative DC cable temperature.
     */
    negCableTemp?: number;
    /**
     * Negative DC Contact temperature.
     */
    negContactTemp: number;
    /**
     * Positive DC cable temperature.
     */
    posCableTemp?: number;
    /**
     * Positive DC Contact temperature.
     */
    posContactTemp: number;
}

export type LCSystemGenericState = 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';

export interface LCSystemInfo {
    /**
     * Hardware version LC system.
     */
    HWVer?: string;
    /**
     * Software version LC system.
     */
    SWVer?: string;
    /**
     * Type of the liquid cooled cable. For example: 'phoenix-liquid-cooled-cable'
     */
    type: string;
}

export type LCSystemLeakageDetectionState = 'Error' | 'Init' | 'LeakageDetected' | 'Triggered' | 'WaitingForTrigger';

export interface LCSystemMetrics {
    /**
     * Hardware version of LC satellite
     */
    HWVer?: string;
    /**
     * Software version of LC satellite
     */
    SWVer?: string;
    /**
     * Temperature metrics of connector
     */
    ccs1?: {
        /**
         * Actual pin temperatures of liquid cooled satellite connector. (Measured from charging plug)
         */
        pinTemperatures?: {
            pinTempDCNeg?: number;
            pinTempDCPos?: number;
        };
        /**
         * Cable temperature of liquid cooled satellite connector.
         */
        cableTemperatures?: {
            cableTempDCNeg?: number;
            cableTempDCPos?: number;
        };
        /**
         * Housing temperature of liquid cooled satellite.
         */
        housingTemperature?: number;
        /**
         * Max housing temperature since up
         */
        maxHousTempSinceUp?: number;
        /**
         * Max cable temperature.
         */
        maxTempDCCabl?: number;
        /**
         * Max cable temperature since connector plugged.
         */
        maxTempDCCablSincePlug?: number;
        /**
         * Max contact temperature
         */
        maxTempDCCont?: number;
    };
    /**
     * Temperature metrics of connector
     */
    ccs2?: {
        /**
         * Actual pin temperatures of liquid cooled satellite connector. (Measured from charging plug)
         */
        pinTemperatures?: {
            pinTempDCNeg?: number;
            pinTempDCPos?: number;
        };
        /**
         * Cable temperature of liquid cooled satellite connector.
         */
        cableTemperatures?: {
            cableTempDCNeg?: number;
            cableTempDCPos?: number;
        };
        /**
         * Housing temperature of liquid cooled satellite.
         */
        housingTemperature?: number;
        /**
         * Max housing temperature since up
         */
        maxHousTempSinceUp?: number;
        /**
         * Max cable temperature.
         */
        maxTempDCCabl?: number;
        /**
         * Max cable temperature since connector plugged.
         */
        maxTempDCCablSincePlug?: number;
        /**
         * Max contact temperature
         */
        maxTempDCCont?: number;
    };
    /**
     * Timestamp when LC data have been updated
     */
    ts?: string;
    /**
     * Type of the liquid cooled cable. For example: 'phoenix-liquid-cooled-cable'
     */
    type?: string;
}

export interface LCSystemPPSignalState {
    /**
     * Status of connector latch
     */
    PPSignalLatchStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
    /**
     * Connector plugin status
     */
    PPSignalPlugStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
    /**
     * PP signal status.
     * PP-Signal state describes, if the HPC is plugged into a car‘s inlet and if the latch (HPC Type 1) is pressed
     */
    PPSignalStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
}

export interface LCSystemStatus {
    /**
     * Coolant level sensor error.
     */
    coolantLevelSensorError: boolean;
    /**
     * Status of cable temperatures and contact temperatures.
     */
    dcTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
    /**
     * Are fans set to on state.
     */
    fansOn: boolean;
    /**
     * Status of LC system housing temperature.
     */
    housingTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
    /**
     * Status of leakage detection.
     */
    leakageDetectionStatus?: 'Error' | 'Init' | 'LeakageDetected' | 'Triggered' | 'WaitingForTrigger';
    /**
     * Status of leakage sensor.
     */
    leakageSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
    /**
     * Overall status of liquid cooled system.
     */
    overallStatus: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
    /**
     * Is lc connector pluggedin.
     */
    pluggedInDetectionStatus?: {
        /**
         * Status of connector latch
         */
        PPSignalLatchStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
        /**
         * Connector plugin status
         */
        PPSignalPlugStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
        /**
         * PP signal status.
         * PP-Signal state describes, if the HPC is plugged into a car‘s inlet and if the latch (HPC Type 1) is pressed
         */
        PPSignalStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
    };
    /**
     * Are pumps set to on state.
     */
    pumpOn: boolean;
    /**
     * Status of shock sensor.
     */
    shockSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
    /**
     * System info of liquid cooled system.
     */
    systemInfo: {
        /**
         * Hardware version LC system.
         */
        HWVer?: string;
        /**
         * Software version LC system.
         */
        SWVer?: string;
        /**
         * Type of the liquid cooled cable. For example: 'phoenix-liquid-cooled-cable'
         */
        type: string;
    };
    /**
     * Current values of temperature sensors.
     */
    temperatures: {
        /**
         * Temperature of the lc satellite housing.
         */
        housingTemp?: number;
        /**
         * Negative DC cable temperature.
         */
        negCableTemp?: number;
        /**
         * Negative DC Contact temperature.
         */
        negContactTemp: number;
        /**
         * Positive DC cable temperature.
         */
        posCableTemp?: number;
        /**
         * Positive DC Contact temperature.
         */
        posContactTemp: number;
    };
    /**
     * Timestamp of when the status was updated.
     */
    timestamp: string;
}

export interface LCTemperatureMetrics {
    /**
     * Actual pin temperatures of liquid cooled satellite connector. (Measured from charging plug)
     */
    pinTemperatures?: {
        pinTempDCNeg?: number;
        pinTempDCPos?: number;
    };
    /**
     * Cable temperature of liquid cooled satellite connector.
     */
    cableTemperatures?: {
        cableTempDCNeg?: number;
        cableTempDCPos?: number;
    };
    /**
     * Housing temperature of liquid cooled satellite.
     */
    housingTemperature?: number;
    /**
     * Max housing temperature since up
     */
    maxHousTempSinceUp?: number;
    /**
     * Max cable temperature.
     */
    maxTempDCCabl?: number;
    /**
     * Max cable temperature since connector plugged.
     */
    maxTempDCCablSincePlug?: number;
    /**
     * Max contact temperature
     */
    maxTempDCCont?: number;
}

/**
 * parsed /proc/loadavg
 * Load average figures giving the number of jobs in the run queue (state R) or waiting for disk I/O (state D) averaged over 1, 5, and 15 minutes
 */
export interface LoadAvgMetrics {
    _15min: number;
    _1min: number;
    _5min: number;
}

/**
 * /proc/meminfo
 */
export interface MemMetrics {
    Buffers: number;
    Cached: number;
    CommitLimit: number;
    Committed_AS: number;
    Mapped: number;
    MemAvailable: number;
    MemFree: number;
    MemTotal: number;
    Shmem: number;
    VmallocChunk: number;
    VmallocTotal: number;
    VmallocUsed: number;
}

export interface OmegaDetails {
    hwRevision?: string;
    role?: 'CABINET' | 'SATELLITE' | 'SLAVE_CABINET' | 'STANDALONE' | 'TROLLEY' | 'LOADMANAGER';
    swVersion?: string;
}
export type EMVStatus = 'ENABLED' | 'DISABLED' | 'ONLINE' | 'OFFLINE' | 'SESSION' | 'VEND_A' | 'VEND_B' | 'UNKNOWN';
export interface PaymentTerminalDetails {
    // Sync with ncm chargerStatus PayterInfo
    terminal_id?: string;
    SAM_serial_0?: string;
    SAM_serial_1?: string;
    SAM_serial_2?: string;
    MAC_address?: string;
    SIM_number?: string;
    firmware_name?: string;
    status?: EMVStatus;
}

export interface OnlineStatus {
    /**
     * Connection end time in ISO8601 format,
     * e.g. 2019-04-10T08:10:23.234Z
     */
    connectionEndTime?: string | null;
    /**
     * Unique connection identifier, if any.
     */
    connectionId?: string | null;
    /**
     * Connection start time in ISO8601 format,
     * e.g. 2019-04-10T06:10:23.234Z
     */
    connectionStartTime?: string | null;
    groupPath?: string | null;
    /**
     * Connection profile id, if any
     */
    id?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    online: boolean;
    settings: null;
    /**
     * Station unique identifier.
     */
    stationId: string;
    /**
     * E.g. free-form ONLINE, OFFLINE, CONNECTING, ..
     */
    status: string;
    /**
     * Integration status timestamp
     */
    timestamp: string;
    /**
     * Connection or integration type
     */
    type: 'charger-ocpp' | 'chargeye' | 'ocpi' | 'ocppbridge20';
}

export interface PatchStationCommissioningRequest {
    commissioning?: StationCommissioning | null;
    confirmed?: boolean | null;
}

export interface PatchStationCommissioningResponse {
    success: boolean;
}

export interface PickAlertRow {
    /**
     * Override Maximum power value in charger UI when Adaptive voltage is not shown.
     */
    ConnectorMaxPowerDisplay?: number;
    /**
     * Override 400V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay400V?: number;
    /**
     * Override 800V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay800V?: number;
    /**
     * Config - Static text to display instead of the Maximum power in kW (e.g. 40 kW)
     */
    MaxPowerDisplay?: string;
    /**
     * Config -Short additional text to display on the charger
     */
    SupplementaryNote?: string;
    /**
     * Actual EVSE identifier - that is, EVSE as in can output to one EV at a time.
     * If multiple "chargeye evses" share this same evseNumber then they belong to the same EVSE.
     * This can be the case for e.g. X-satellites or some Trolleys configured as Sequential.
     * In 3rd party chargers this will be the evse uid.
     */
    actualEVSEId?: string | number;
    /**
     * ChargingPriority for this connector (-9 ... 9 as of OSCP2.0.1 in 1.60.2. TransactionEventResponse)
     */
    chargingPriority?: number | null;
    /**
     * Used to deduce whether or not the evse is currently in active configuration
     */
    configurationId?: number;
    /**
     * If true, this alert has been "dismissed" and hidden from view
     */
    dismissed?: boolean;
    /**
     * when this notification was dismissed
     */
    dismissedTimestamp?: string;
    /**
     * user who dismissed this notification
     */
    dismissedUserId?: string;
    /**
     * ID of energy meter, if known.
     */
    eMeterId?: string | null;
    /**
     * True if energy meter is available for this connector.
     */
    eMeterPresent?: boolean | null;
    /**
     * Public key of energy meter, if known.
     */
    eMeterPublicKey?: string | null;
    /**
     * end timestamp for this alert
     */
    endTime?: string;
    /**
     * Error code
     */
    errorCode?: string;
    /**
     * EVSE unique identifier.
     */
    evseId: string;
    /**
     * Name of the evse/connector
     */
    evseName?: string;
    /**
     * Type of the evse/connector
     */
    evseType?: 'AC' | 'CCS' | 'CHAdeMO' | 'Type2' | 'oppcharge';
    groupPath?: string | null;
    /**
     * synthetic alert id
     */
    id?: string;
    /**
     * Connector Geo latitude
     */
    lat?: number;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    liquidCoolingSystem?: {
        /**
         * Coolant level sensor error.
         */
        coolantLevelSensorError: boolean;
        /**
         * Status of cable temperatures and contact temperatures.
         */
        dcTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Are fans set to on state.
         */
        fansOn: boolean;
        /**
         * Status of LC system housing temperature.
         */
        housingTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Status of leakage detection.
         */
        leakageDetectionStatus?: 'Error' | 'Init' | 'LeakageDetected' | 'Triggered' | 'WaitingForTrigger';
        /**
         * Status of leakage sensor.
         */
        leakageSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Overall status of liquid cooled system.
         */
        overallStatus: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Is lc connector pluggedin.
         */
        pluggedInDetectionStatus?: {
            /**
             * Status of connector latch
             */
            PPSignalLatchStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * Connector plugin status
             */
            PPSignalPlugStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * PP signal status.
             * PP-Signal state describes, if the HPC is plugged into a car‘s inlet and if the latch (HPC Type 1) is pressed
             */
            PPSignalStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        };
        /**
         * Are pumps set to on state.
         */
        pumpOn: boolean;
        /**
         * Status of shock sensor.
         */
        shockSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * System info of liquid cooled system.
         */
        systemInfo: {
            /**
             * Hardware version LC system.
             */
            HWVer?: string;
            /**
             * Software version LC system.
             */
            SWVer?: string;
            /**
             * Type of the liquid cooled cable. For example: 'phoenix-liquid-cooled-cable'
             */
            type: string;
        };
        /**
         * Current values of temperature sensors.
         */
        temperatures: {
            /**
             * Temperature of the lc satellite housing.
             */
            housingTemp?: number;
            /**
             * Negative DC cable temperature.
             */
            negCableTemp?: number;
            /**
             * Negative DC Contact temperature.
             */
            negContactTemp: number;
            /**
             * Positive DC cable temperature.
             */
            posCableTemp?: number;
            /**
             * Positive DC Contact temperature.
             */
            posContactTemp: number;
        };
        /**
         * Timestamp of when the status was updated.
         */
        timestamp: string;
    } | null;
    /**
     * Connector Geo longitude
     */
    lng?: number;
    /**
     * Location this EVSE lies in
     */
    locationUid?: string;
    /**
     * Max connector cable current, e.g. 100 or 125 A
     */
    maxCableCurrent?: number;
    /**
     * Maximum power in kilowatts that this connector could output
     */
    maxPowerKw?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed
     */
    maxPowerKwWithoutDynamicLimit?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed (unrounded figure)
     */
    maxPowerKwWithoutDynamicLimitActual?: number;
    /**
     * Maximum power in kilowatts that this connector could output (unrounded figure)
     */
    maxPowerkWActual?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics)
     */
    maxPowerkWPresent?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics) (unrounded figure)
     */
    maxPowerkWPresentActual?: number;
    /**
     * Maximum voltage this EVSE can output (500 or 800V)
     */
    maxVoltage?: number;
    /**
     * Error message, or other details
     */
    message?: string;
    payload?: {
        [k: string]: any;
    } | null;
    /**
     * Station unique identifier.
     */
    stationId: string;
    tariffIds?: string[] | null;
    /**
     * When alert became active.
     * e.g. 2019-04-10T06:10:23.234Z
     */
    timestamp: string;
    /**
     * error message title
     */
    title?: string;
    /**
     * Type/code of the alert
     */
    type: string;
}

export interface PickChargingStationRow {
    tenantIds?: string[];
    commissioningRequired?: boolean | null;
    customer?: {
        id?: string;
        name?: string;
    };
    /**
     * ID a customer has given to this station
     */
    customerSuppliedId?: string;
    firmwareVersion?: string | null;
    groupPath?: string | null;
    labels?: CeCommonLabel[] | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    location?: {
        address?: string | null;
        id?: string;
        lat?: number | null;
        lng?: number | null;
        locationId?: string | null;
        name?: string | null;
        roamingPoolId?: string;
    } | null;
    locationUid?: string | null;
    /**
     * Factory filled-in information about the charger
     */
    manufacturingInfo?: {
        /**
         * Date when charger was shippped to customer
         */
        deliveryDate?: string | null;
        extraOrders?: string[] | null;
        /**
         * Kempower order number
         */
        orderNumber?: string | null;
        /**
         * Original customer id
         */
        partnerId?: string | null;
        /**
         * Original customer name
         */
        partnerName?: string | null;
        /**
         * Product code e.g. C502P240ND4
         */
        productId?: string;
        /**
         * e.g. Charging Power Unit 500V/300kW/D4
         */
        productName?: string;
        /**
         * Serial number when manufactured
         */
        serialNumber?: string;
        /**
         * e.g. Inventory
         */
        serialNumberStatus?: string | null;
        /**
         * e.g. DEMO
         */
        stock?: string | null;
    };
    /**
     * Charger maximum output power at any point in time in kilowatts. How much power it can output simultaneously to all its connectors.
     */
    maxPowerKw?: number;
    model?: string | null;
    name: string;
    notes?: string | null;
    operationalStatus?: ('IN_OPERATION' | 'NOT_IN_OPERATION' | 'OUT_OF_ORDER') | null;
    operator?: string | null;
    /**
     * Capabilities that the station supports as a comma separated list.
     * For example when station supports serial connectable power modules,
     * contents would be:
     * stationCapabilities = "SerialConnection,Xxx, ... ,Yyy"
     */
    stationCapabilities?: string | null;
    /**
     * Station unique identifier.
     */
    stationId: string;
    vendorName?: string | null;
}

export interface PickConnectionRow {
    /**
     * Country code of the client, as detected from IP address (by CloudFront in the 'Cloudfront-Viewer-Country' header).
     * The value is a two-letter country code (ISO 3166-1 alpha 2), like US (for USA) or TW (for Taiwan).
     * See https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2 for a list of countries.
     */
    clientCountryCode?: string;
    /**
     * IP address of the client
     */
    clientIpAddress: string;
    /**
     * Time when connection was ended or disconnected in ISO8601 format.
     * e.g. 2019-04-10T06:10:23.234Z
     */
    connectionEndTime?: string;
    /**
     * Unique connection identifier.
     */
    connectionId: string;
    /**
     * Connection start time in ISO8601 format,
     * e.g. 2019-04-10T06:10:23.234Z
     */
    connectionStartTime: string;
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    /**
     * Ocpi connection profile id related to this connection;
     */
    ocpiConnectionProfileId?: string;
    /**
     * Station unique identifier.
     */
    stationId: string;
    /**
     * Connection type - direct to charger or another backend?
     * Defaults to ocpp
     */
    type?: 'ocpi' | 'ocpp';
    /**
     * Connection version based on standards
     */
    version?: 'ocpi2.2' | 'ocpp1.6j' | 'ocpp2-kempower';
}

export interface PickIntegrationSettingsRow {
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    /**
     * Collection of ids for the ocpi connection profiles
     */
    ocpiConnectionProfileIds: string[];
    /**
     * Station unique identifier.
     */
    stationId: string;
}

export interface PickOnlineStatusRow {
    /**
     * Connection end time in ISO8601 format,
     * e.g. 2019-04-10T08:10:23.234Z
     */
    connectionEndTime?: string | null;
    /**
     * Unique connection identifier, if any.
     */
    connectionId?: string | null;
    /**
     * Connection start time in ISO8601 format,
     * e.g. 2019-04-10T06:10:23.234Z
     */
    connectionStartTime?: string | null;
    groupPath?: string | null;
    /**
     * Connection profile id, if any
     */
    id?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    online: boolean;
    settings: null;
    /**
     * Station unique identifier.
     */
    stationId: string;
    /**
     * E.g. free-form ONLINE, OFFLINE, CONNECTING, ..
     */
    status: string;
    /**
     * Integration status timestamp
     */
    timestamp: string;
    /**
     * Connection or integration type
     */
    type: 'charger-ocpp' | 'chargeye' | 'ocpi' | 'ocppbridge20';
}

export interface PickSettingsRow {
    applyVerified?: boolean;
    configuration: BaseConfiguration;
    controllingSystem?: 'cloud' | 'device';
    externalCloudConfiguration?: ExternalCloudConfiguration | null;
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    settingsProfile?: SettingsProfileInfo | null;
    settingsSource?: string;
    /**
     * Station unique identifier.
     */
    stationId: string;
}

export interface PickStatusRow {
    /**
     * Override Maximum power value in charger UI when Adaptive voltage is not shown.
     */
    ConnectorMaxPowerDisplay?: number;
    /**
     * Override 400V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay400V?: number;
    /**
     * Override 800V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay800V?: number;
    /**
     * Config - Static text to display instead of the Maximum power in kW (e.g. 40 kW)
     */
    MaxPowerDisplay?: string;
    /**
     * Config -Short additional text to display on the charger
     */
    SupplementaryNote?: string;
    /**
     * Actual EVSE identifier - that is, EVSE as in can output to one EV at a time.
     * If multiple "chargeye evses" share this same evseNumber then they belong to the same EVSE.
     * This can be the case for e.g. X-satellites or some Trolleys configured as Sequential.
     * In 3rd party chargers this will be the evse uid.
     */
    actualEVSEId?: string | number;
    /**
     * ChargingPriority for this connector (-9 ... 9 as of OSCP2.0.1 in 1.60.2. TransactionEventResponse)
     */
    chargingPriority?: number | null;
    /**
     * Used to deduce whether or not the evse is currently in active configuration
     */
    configurationId?: number;
    /**
     * More detailed reason why status is unavailable
     */
    detail?: string;
    /**
     * ID of energy meter, if known.
     */
    eMeterId?: string | null;
    /**
     * True if energy meter is available for this connector.
     */
    eMeterPresent?: boolean | null;
    /**
     * Public key of energy meter, if known.
     */
    eMeterPublicKey?: string | null;
    /**
     * EVSE unique identifier.
     */
    evseId: string;
    /**
     * Name of the evse/connector
     */
    evseName?: string;
    /**
     * Type of the evse/connector
     */
    evseType?: 'AC' | 'CCS' | 'CHAdeMO' | 'Type2' | 'oppcharge';
    groupPath?: string | null;
    /**
     * Connector Geo latitude
     */
    lat?: number;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    liquidCoolingSystem?: {
        /**
         * Coolant level sensor error.
         */
        coolantLevelSensorError: boolean;
        /**
         * Status of cable temperatures and contact temperatures.
         */
        dcTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Are fans set to on state.
         */
        fansOn: boolean;
        /**
         * Status of LC system housing temperature.
         */
        housingTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Status of leakage detection.
         */
        leakageDetectionStatus?: 'Error' | 'Init' | 'LeakageDetected' | 'Triggered' | 'WaitingForTrigger';
        /**
         * Status of leakage sensor.
         */
        leakageSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Overall status of liquid cooled system.
         */
        overallStatus: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Is lc connector pluggedin.
         */
        pluggedInDetectionStatus?: {
            /**
             * Status of connector latch
             */
            PPSignalLatchStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * Connector plugin status
             */
            PPSignalPlugStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * PP signal status.
             * PP-Signal state describes, if the HPC is plugged into a car‘s inlet and if the latch (HPC Type 1) is pressed
             */
            PPSignalStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        };
        /**
         * Are pumps set to on state.
         */
        pumpOn: boolean;
        /**
         * Status of shock sensor.
         */
        shockSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * System info of liquid cooled system.
         */
        systemInfo: {
            /**
             * Hardware version LC system.
             */
            HWVer?: string;
            /**
             * Software version LC system.
             */
            SWVer?: string;
            /**
             * Type of the liquid cooled cable. For example: 'phoenix-liquid-cooled-cable'
             */
            type: string;
        };
        /**
         * Current values of temperature sensors.
         */
        temperatures: {
            /**
             * Temperature of the lc satellite housing.
             */
            housingTemp?: number;
            /**
             * Negative DC cable temperature.
             */
            negCableTemp?: number;
            /**
             * Negative DC Contact temperature.
             */
            negContactTemp: number;
            /**
             * Positive DC cable temperature.
             */
            posCableTemp?: number;
            /**
             * Positive DC Contact temperature.
             */
            posContactTemp: number;
        };
        /**
         * Timestamp of when the status was updated.
         */
        timestamp: string;
    } | null;
    /**
     * Connector Geo longitude
     */
    lng?: number;
    /**
     * Location this EVSE lies in
     */
    locationUid?: string;
    /**
     * Max connector cable current, e.g. 100 or 125 A
     */
    maxCableCurrent?: number;
    /**
     * Maximum power in kilowatts that this connector could output
     */
    maxPowerKw?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed
     */
    maxPowerKwWithoutDynamicLimit?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed (unrounded figure)
     */
    maxPowerKwWithoutDynamicLimitActual?: number;
    /**
     * Maximum power in kilowatts that this connector could output (unrounded figure)
     */
    maxPowerkWActual?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics)
     */
    maxPowerkWPresent?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics) (unrounded figure)
     */
    maxPowerkWPresentActual?: number;
    /**
     * Maximum voltage this EVSE can output (500 or 800V)
     */
    maxVoltage?: number;
    /**
     * Reason for why the status is unavailable
     */
    reason?: string;
    /**
     * Station unique identifier.
     */
    stationId: string;
    /**
     * Status of the EVSE or Charging station.
     */
    status: 'Available' | 'Charging' | 'Faulted' | 'Occupied' | 'Operative' | 'Reserved' | 'Unavailable' | 'Unknown';
    /**
     * When status became active.
     * e.g. 2019-04-10T06:10:23.234Z
     */
    statusDate: string;
    tariffIds?: string[] | null;
}

export interface PickSystemMetricsRow {
    additionalMetrics?: {
        pmcChargingCount?: number;
        pmcCount?: number;
    };
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    metrics: SatelliteMetrics;
    /**
     * Satellite id in which these were measured, or 0 for the cabinet
     */
    satelliteId: number;
    /**
     * Station unique identifier.
     */
    stationId: string;
    /**
     * When the metrics were recorded.
     */
    timestamp: string;
    type: 'CABINET' | 'SATELLITE' | 'SLAVE_CABINET' | 'STANDALONE' | 'TROLLEY' | 'LOADMANAGER';
}

export interface PickSystemStructureRow {
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    /**
     * Station unique identifier.
     */
    stationId: string;
    structure: any;
    /**
     * When the structure were recorded.
     */
    timestamp: string;
}

export interface PinTemperatureMetrics {
    ccs1?: CablePinTemperatureMetrics;
    ccs2?: CablePinTemperatureMetrics;
}

export interface PmcAlert {
    problem?: string;
    /**
     * Example values: 'BROKEN' | 'PARTIALLY_BROKEN'
     */
    severity?: string;
}

export interface PostChargingStationAttachmentsRequest {
    attachments: StationAttachment[];
}

export interface PostChargingStationAttachmentsResponse {
    attachments: StationAttachment[];
}

export interface PostChargingStationRequest {
    /**
     * ID a customer has given to this station
     */
    customerSuppliedId?: string;
    firmwareVersion?: string;
    groupPath?: string;
    location?: null;
    locationUid?: string;
    model?: string;
    name: string;
    stationId?: string;
    vendorName?: string;
}

export interface PostChargingStationResponse {
    id: string;
}

export interface PowerModuleDetails {
    alerts?: PmcAlert[];
    applicationVersion?: string;
    boardRevision?: number;
    bootVersion?: string;
    can?: string;
    device?: string;
    family?: string;
    featureFlags?: string[];
    manufacturingDate?: string;
    maxVoltage?: string;
    moduleSerialNumber?: string;
    powerKw?: number;
}

export interface PutChargingStationRequest {
    classification?: {
        access?: 'PUBLIC' | 'PRIVATE';
    };
    commissioningRequired?: boolean | null;
    customer?: {
        id?: string;
        name?: string;
    };
    firmwareVersion?: string | null;
    groupPath?: string | null;
    labels?: CeCommonLabel[] | null;
    location?: {
        address?: string | null;
        id?: string;
        lat?: number | null;
        lng?: number | null;
        locationId?: string | null;
        name?: string | null;
        roamingPoolId?: string;
    } | null;
    locationUid?: string | null;
    /**
     * Factory filled-in information about the charger
     */
    manufacturingInfo?: {
        /**
         * Date when charger was shippped to customer
         */
        deliveryDate?: string | null;
        extraOrders?: string[] | null;
        /**
         * Kempower order number
         */
        orderNumber?: string | null;
        /**
         * Original customer id
         */
        partnerId?: string | null;
        /**
         * Original customer name
         */
        partnerName?: string | null;
        /**
         * Product code e.g. C502P240ND4
         */
        productId?: string;
        /**
         * e.g. Charging Power Unit 500V/300kW/D4
         */
        productName?: string;
        /**
         * Serial number when manufactured
         */
        serialNumber?: string;
        /**
         * e.g. Inventory
         */
        serialNumberStatus?: string | null;
        /**
         * e.g. DEMO
         */
        stock?: string | null;
    };
    model?: string | null;
    name?: string;
    notes?: string | null;
    operationalStatus?: ('IN_OPERATION' | 'NOT_IN_OPERATION' | 'OUT_OF_ORDER') | null;
    operator?: string | null;
    /**
     * Capabilities that the station supports as a comma separated list.
     * For example when station supports serial connectable power modules,
     * contents would be:
     * stationCapabilities = "SerialConnection,Xxx, ... ,Yyy"
     */
    stationCapabilities?: string | null;
    vendorName?: string | null;
}

export interface PutChargingStationResponse {
    _gsi1pk: string;
    _gsi1sk: string;
    _gsi2pk: string;
    _gsi2sk: string;
    _gsiTenantCPOPk: string;
    _gsiTenantCPOSk: string;
    _gsiTenantEMSPPk: string;
    _gsiTenantEMSPSk: string;
    _gsiTenantMaintenancePk: string;
    _gsiTenantMaintenanceSk: string;
    _pk: string;
    _sk: string;
    /**
     * DynamoDB TTL (Time to Live) - item expiry time (unix timestamp).
     * Set for scheduled deletion of item row.
     * Please note this is SECONDS (unix timestamp) not MILLISECONDS (like usually in javascript).
     */
    _ttl?: number;
    commissioningRequired?: boolean | null;
    customer?: {
        id?: string;
        name?: string;
    };
    /**
     * ID a customer has given to this station
     */
    customerSuppliedId?: string;
    deleted?: boolean;
    firmwareVersion?: string | null;
    groupPath?: string | null;
    labels?: CeCommonLabel[] | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    location?: {
        address?: string | null;
        id?: string;
        lat?: number | null;
        lng?: number | null;
        locationId?: string | null;
        name?: string | null;
        roamingPoolId?: string;
    } | null;
    locationUid?: string | null;
    /**
     * Factory filled-in information about the charger
     */
    manufacturingInfo?: {
        /**
         * Date when charger was shippped to customer
         */
        deliveryDate?: string | null;
        extraOrders?: string[] | null;
        /**
         * Kempower order number
         */
        orderNumber?: string | null;
        /**
         * Original customer id
         */
        partnerId?: string | null;
        /**
         * Original customer name
         */
        partnerName?: string | null;
        /**
         * Product code e.g. C502P240ND4
         */
        productId?: string;
        /**
         * e.g. Charging Power Unit 500V/300kW/D4
         */
        productName?: string;
        /**
         * Serial number when manufactured
         */
        serialNumber?: string;
        /**
         * e.g. Inventory
         */
        serialNumberStatus?: string | null;
        /**
         * e.g. DEMO
         */
        stock?: string | null;
    };
    /**
     * Charger maximum output power at any point in time in kilowatts. How much power it can output simultaneously to all its connectors.
     */
    maxPowerKw?: number;
    model?: string | null;
    name: string;
    notes?: string | null;
    operationalStatus?: ('IN_OPERATION' | 'NOT_IN_OPERATION' | 'OUT_OF_ORDER') | null;
    operator?: string | null;
    schema: string;
    schemaVersion?: number;
    /**
     * Capabilities that the station supports as a comma separated list.
     * For example when station supports serial connectable power modules,
     * contents would be:
     * stationCapabilities = "SerialConnection,Xxx, ... ,Yyy"
     */
    stationCapabilities?: string | null;
    /**
     * Station unique identifier.
     */
    stationId: string;
    tenantIdCPO: string;
    tenantIdEMSP: string;
    tenantIdMaintenance: string;
    /**
     * Which tenants has access to this row
     */
    tenantIds: string[];
    vendorName?: string | null;
    versionCreatedTenantId: string;
    versionCreatedTimestamp: string;
    versionCreatedUserId: string;
    versionCreatedUserRole: string;
    versionDeletedTimestamp?: string;
    versionDeletedUserId: string;
    versionModifiedTimestamp: string;
    versionModifiedUserId: string;
}

export interface PutChargingStationTenantsRequest {
    tenantIdCPO?: string;
    tenantIdEMSP?: string;
    tenantIdMaintenance?: string;
}

export interface PutChargingStationTenantsResponse {
    success: boolean;
}

export interface PutStationInventoryRequest {
    inventory: StationInventoryEntry[];
}

export interface PutStationInventoryResponse {
    success: boolean;
}

export interface PutWarrantyHistoryResponse {
    success: boolean;
}

export interface ResponseDevice {
    compatible: boolean;
    description?: string;
    device: StationInvetoryEntryCanDeviceExtra | StationInvetoryEntrySatellite;
}

export interface SatelliteMetrics {
    bootId?: string;
    cloud?: {
        /**
         * This interface was referenced by `undefined`'s JSON-Schema definition
         * via the `patternProperty` "^[0-9]+$".
         */
        [k: string]: {
            bufferedCount?: number;
            config?: {
                enabled: boolean;
                endpoint: string;
                identity: string;
                /**
                 * network interface dedicated for this connection, e.g. if a VPN tunneled connection is required
                 */
                interface?: 'legacyUsbModem' | 'lteExternal' | 'lteInternal' | 'wifi' | 'wired' | 'wiredInternal';
                token: string;
                tracing?: boolean;
            };
            /**
             * Latency in ms of request-responses with ocpp server, of past 1 hour
             */
            latencyStats?: {
                avg: number;
                count: number;
                median: number;
                p10: number;
                p90: number;
            };
            online: boolean;
            sendFailuresCount?: number;
            sendFailuresCountPast1h?: number;
            timestamp: string;
        };
    };
    cpu: CpuMetrics;
    disk: DiskMetrics;
    hwRevision?: string;
    ifstats?: {
        [k: string]: {
            rx: number;
            tx: number;
        };
    };
    liquidCoolingSystem?: LCSystemMetrics;
    loadavg: LoadAvgMetrics;
    mem: MemMetrics;
    network?: {
        external?: SatelliteMetricsNetwork;
        internal?: SatelliteMetricsNetwork;
        legacy?: SatelliteMetricsNetwork;
        wired?: SatelliteMetricsNetwork;
        wlan?: SatelliteMetricsNetwork;
    };
    pinTemps: PinTemperatureMetrics;
    pmcStatus?: {
        alarms?: string[];
        boardTemp?: number;
        canAddress: number;
        canRxOverruns?: number;
        canTxFail?: number;
        counters?: {
            [k: string]: {
                started: number;
                value: number;
            };
        };
        dcVoltage?: number;
        present?: boolean;
        /**
         * pmc serialnumber, e.g. PSNQ0118476
         */
        serialNumber?: string;
        state?: string;
        trTemp?: number;
    }[];
    powerStats?: {
        avg: number;
        max: number;
        min: number;
    };
    productCode?: string;
    satId: number;
    serialNumber?: string;
    sshport?: number;
    swVersion?: string;
    temp: number;
    tempCore?: number;
    trigger?: 'Alerting' | 'Periodic';
    ts: string;
    type: 'CABINET' | 'SATELLITE' | 'SLAVE_CABINET' | 'STANDALONE' | 'TROLLEY' | 'LOADMANAGER';
    uptime?: number;
}

export interface SatelliteMetricsNetwork {
    interfaceName: string;
    /**
     * e.g. 192.168.100.200/24
     */
    ip: string;
    linkState?: string;
    macAddress?: string;
    present: boolean;
    ssid?: string;
}

export interface Settings {
    applyVerified?: boolean;
    configuration: BaseConfiguration;
    controllingSystem?: 'cloud' | 'device';
    externalCloudConfiguration?: ExternalCloudConfiguration | null;
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    settingsProfile?: SettingsProfileInfo | null;
    settingsSource?: string;
    /**
     * Station unique identifier.
     */
    stationId: string;
}

export interface SettingsProfileInfo {
    applyTimestamp?: string;
    id?: string;
    name?: string;
    ownerTenantId?: string;
    ownerTenantName?: string;
    profileTimestamp?: string;
}

export interface StationAttachment {
    contentType: string;
    fileId?: string;
    fileKey?: string;
    /**
     * Original name of the file
     */
    fileName: string;
    fileSize?: number;
    /**
     * Enables basic storage and retrieval of dates and times.
     */
    lastModified?: string;
    temporaryUploadUrl?: string;
    temporaryUrl?: string;
}

export interface StationCommissioning {
    completed?: boolean | null;
    completedTimestamp?: string | null;
    completedUserId?: string | null;
    completedUserName?: string | null;
    notes?: string | null;
    stationId: string;
    steps?: {
        [k: string]: StationCommissioningStep;
    } | null;
}

export interface StationInfo {
    /**
     * AC-DC conversion ratio
     */
    acDcPowerRatio?: number;
    connectors: ConnectorInfo[];
    /**
     * Current intake at present (amperes) of the station
     */
    currentPowerA?: number;
    /**
     * Current output power (kW) of the station
     */
    currentPowerKw?: number;
    labels?: CeCommonLabel[] | null;
    location: {
        address: string;
        lat: number;
        lng: number;
        name: string;
    };
    /**
     * Maximum input current (amperes) of the station
     * that it could theoretically take with current configuration.
     * Equals to PMC input supply current.
     * Dynamic limits (charging profiles) do not affect this.
     */
    maxPowerA?: number;
    /**
     * MAX output power (kW) of the station undefined if not known
     */
    maxPowerKw?: number;
    name: string;
    onlineStatus: 'Offline' | 'Online';
    /**
     * Path in powerGroup tree, 0th value is the id of root. This station does not belong to a power group if this is null/empty
     */
    powerGroupParentPath?: string[];
    /**
     * Capabilities that the station supports as a comma separated list.
     * For example when station supports serial connectable power modules,
     * contents would be:
     * stationCapabilities = "SerialConnection,Xxx, ... ,Yyy"
     */
    stationCapabilities?: string | null;
    stationId: string;
    status: ChargingStationStatus;
}

export interface StationInventoryEntry {
    build_time?: string | null;
    can_devices?: StationInvetoryEntryCanDevice[] | null;
    external_serialnumber?: string | null;
    id?: string | null;
    ip4?: string | null;
    ip6?: string | null;
    productcode?: string | null;
    repository_revision?: string | null;
    setup_mode_enabled?: boolean | null;
    type?: string | null;
    version?: string | null;
}

export interface StationInvetoryEntryCanDevice {
    address?: number | null;
    app?: string | null;
    boot?: string | null;
    device?: string | null;
    pmc_board_version?: string | null;
    pmc_voltage?: string | null;
    relaycard_type?: string | null;
    sn?: string | null;
    ts?: string | null;
}

export interface StationInvetoryEntryCanDeviceExtra {
    address?: number | null;
    app?: string | null;
    boot?: string | null;
    cabinetId?: string;
    cabinetProductCode?: string;
    device?: string | null;
    /**
     * PMC external serial number
     */
    moduleSerialNumber?: string;
    pmc_board_version?: string | null;
    pmc_voltage?: string | null;
    relaycard_type?: string | null;
    sn?: string | null;
    ts?: string | null;
}

export interface StationInvetoryEntrySatellite {
    build_time?: string | null;
    can_devices?: StationInvetoryEntryCanDevice[] | null;
    external_serialnumber?: string | null;
    id?: string | null;
    ip4?: string | null;
    ip6?: string | null;
    meascard?: {
        type?: string;
        [k: string]: any;
    };
    productcode?: string | null;
    repository_revision?: string | null;
    setup_mode_enabled?: boolean | null;
    type?: string | null;
    version?: string | null;
}

export interface StationManufacturingInfo {
    /**
     * Date when charger was shippped to customer
     */
    deliveryDate?: string | null;
    extraOrders?: string[] | null;
    /**
     * Kempower order number
     */
    orderNumber?: string | null;
    /**
     * Original customer id
     */
    partnerId?: string | null;
    /**
     * Original customer name
     */
    partnerName?: string | null;
    /**
     * Product code e.g. C502P240ND4
     */
    productId?: string;
    /**
     * e.g. Charging Power Unit 500V/300kW/D4
     */
    productName?: string;
    /**
     * Serial number when manufactured
     */
    serialNumber?: string;
    /**
     * e.g. Inventory
     */
    serialNumberStatus?: string | null;
    /**
     * e.g. DEMO
     */
    stock?: string | null;
}

export type StationOperationalStatus = 'IN_OPERATION' | 'NOT_IN_OPERATION' | 'OUT_OF_ORDER';

export interface Status {
    /**
     * Override Maximum power value in charger UI when Adaptive voltage is not shown.
     */
    ConnectorMaxPowerDisplay?: number;
    /**
     * Override 400V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay400V?: number;
    /**
     * Override 800V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay800V?: number;
    /**
     * Config - Static text to display instead of the Maximum power in kW (e.g. 40 kW)
     */
    MaxPowerDisplay?: string;
    /**
     * Config -Short additional text to display on the charger
     */
    SupplementaryNote?: string;
    /**
     * Actual EVSE identifier - that is, EVSE as in can output to one EV at a time.
     * If multiple "chargeye evses" share this same evseNumber then they belong to the same EVSE.
     * This can be the case for e.g. X-satellites or some Trolleys configured as Sequential.
     * In 3rd party chargers this will be the evse uid.
     */
    actualEVSEId?: string | number;
    /**
     * ChargingPriority for this connector (-9 ... 9 as of OSCP2.0.1 in 1.60.2. TransactionEventResponse)
     */
    chargingPriority?: number | null;
    /**
     * Used to deduce whether or not the evse is currently in active configuration
     */
    configurationId?: number;
    /**
     * More detailed reason why status is unavailable
     */
    detail?: string;
    /**
     * ID of energy meter, if known.
     */
    eMeterId?: string | null;
    /**
     * True if energy meter is available for this connector.
     */
    eMeterPresent?: boolean | null;
    /**
     * Public key of energy meter, if known.
     */
    eMeterPublicKey?: string | null;
    /**
     * EVSE unique identifier.
     */
    evseId: string;
    /**
     * Name of the evse/connector
     */
    evseName?: string;
    /**
     * Type of the evse/connector
     */
    evseType?: 'AC' | 'CCS' | 'CHAdeMO' | 'Type2' | 'oppcharge';
    groupPath?: string | null;
    /**
     * Connector Geo latitude
     */
    lat?: number;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    liquidCoolingSystem?: {
        /**
         * Coolant level sensor error.
         */
        coolantLevelSensorError: boolean;
        /**
         * Status of cable temperatures and contact temperatures.
         */
        dcTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Are fans set to on state.
         */
        fansOn: boolean;
        /**
         * Status of LC system housing temperature.
         */
        housingTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Status of leakage detection.
         */
        leakageDetectionStatus?: 'Error' | 'Init' | 'LeakageDetected' | 'Triggered' | 'WaitingForTrigger';
        /**
         * Status of leakage sensor.
         */
        leakageSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Overall status of liquid cooled system.
         */
        overallStatus: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Is lc connector pluggedin.
         */
        pluggedInDetectionStatus?: {
            /**
             * Status of connector latch
             */
            PPSignalLatchStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * Connector plugin status
             */
            PPSignalPlugStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * PP signal status.
             * PP-Signal state describes, if the HPC is plugged into a car‘s inlet and if the latch (HPC Type 1) is pressed
             */
            PPSignalStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        };
        /**
         * Are pumps set to on state.
         */
        pumpOn: boolean;
        /**
         * Status of shock sensor.
         */
        shockSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * System info of liquid cooled system.
         */
        systemInfo: {
            /**
             * Hardware version LC system.
             */
            HWVer?: string;
            /**
             * Software version LC system.
             */
            SWVer?: string;
            /**
             * Type of the liquid cooled cable. For example: 'phoenix-liquid-cooled-cable'
             */
            type: string;
        };
        /**
         * Current values of temperature sensors.
         */
        temperatures: {
            /**
             * Temperature of the lc satellite housing.
             */
            housingTemp?: number;
            /**
             * Negative DC cable temperature.
             */
            negCableTemp?: number;
            /**
             * Negative DC Contact temperature.
             */
            negContactTemp: number;
            /**
             * Positive DC cable temperature.
             */
            posCableTemp?: number;
            /**
             * Positive DC Contact temperature.
             */
            posContactTemp: number;
        };
        /**
         * Timestamp of when the status was updated.
         */
        timestamp: string;
    } | null;
    /**
     * Connector Geo longitude
     */
    lng?: number;
    /**
     * Location this EVSE lies in
     */
    locationUid?: string;
    /**
     * Max connector cable current, e.g. 100 or 125 A
     */
    maxCableCurrent?: number;
    /**
     * Maximum power in kilowatts that this connector could output
     */
    maxPowerKw?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed
     */
    maxPowerKwWithoutDynamicLimit?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed (unrounded figure)
     */
    maxPowerKwWithoutDynamicLimitActual?: number;
    /**
     * Maximum power in kilowatts that this connector could output (unrounded figure)
     */
    maxPowerkWActual?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics)
     */
    maxPowerkWPresent?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics) (unrounded figure)
     */
    maxPowerkWPresentActual?: number;
    /**
     * Maximum voltage this EVSE can output (500 or 800V)
     */
    maxVoltage?: number;
    /**
     * Reason for why the status is unavailable
     */
    reason?: string;
    /**
     * Station unique identifier.
     */
    stationId: string;
    /**
     * Status of the EVSE or Charging station.
     */
    status: 'Available' | 'Charging' | 'Faulted' | 'Occupied' | 'Operative' | 'Reserved' | 'Unavailable' | 'Unknown';
    /**
     * When status became active.
     * e.g. 2019-04-10T06:10:23.234Z
     */
    statusDate: string;
    tariffIds?: string[] | null;
}

export interface StatusRow {
    /**
     * Override Maximum power value in charger UI when Adaptive voltage is not shown.
     */
    ConnectorMaxPowerDisplay?: number;
    /**
     * Override 400V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay400V?: number;
    /**
     * Override 800V Maximum power value in charger UI when Adaptive voltage is shown.
     */
    ConnectorMaxPowerDisplay800V?: number;
    /**
     * Config - Static text to display instead of the Maximum power in kW (e.g. 40 kW)
     */
    MaxPowerDisplay?: string;
    /**
     * Config -Short additional text to display on the charger
     */
    SupplementaryNote?: string;
    _gsi1pk: string;
    _gsi1sk: string;
    _gsi2pk: string;
    _gsi2sk: string;
    _gsiTenantCPOPk: string;
    _gsiTenantCPOSk: string;
    _gsiTenantEMSPPk: string;
    _gsiTenantEMSPSk: string;
    _gsiTenantMaintenancePk: string;
    _gsiTenantMaintenanceSk: string;
    _pk: string;
    _sk: string;
    /**
     * DynamoDB TTL (Time to Live) - item expiry time (unix timestamp).
     * Set for scheduled deletion of item row.
     * Please note this is SECONDS (unix timestamp) not MILLISECONDS (like usually in javascript).
     */
    _ttl?: number;
    /**
     * Actual EVSE identifier - that is, EVSE as in can output to one EV at a time.
     * If multiple "chargeye evses" share this same evseNumber then they belong to the same EVSE.
     * This can be the case for e.g. X-satellites or some Trolleys configured as Sequential.
     * In 3rd party chargers this will be the evse uid.
     */
    actualEVSEId?: string | number;
    /**
     * ChargingPriority for this connector (-9 ... 9 as of OSCP2.0.1 in 1.60.2. TransactionEventResponse)
     */
    chargingPriority?: number | null;
    /**
     * Used to deduce whether or not the evse is currently in active configuration
     */
    configurationId?: number;
    deleted?: boolean;
    /**
     * More detailed reason why status is unavailable
     */
    detail?: string;
    /**
     * ID of energy meter, if known.
     */
    eMeterId?: string | null;
    /**
     * True if energy meter is available for this connector.
     */
    eMeterPresent?: boolean | null;
    /**
     * Public key of energy meter, if known.
     */
    eMeterPublicKey?: string | null;
    /**
     * EVSE unique identifier.
     */
    evseId: string;
    /**
     * Name of the evse/connector
     */
    evseName?: string;
    /**
     * Type of the evse/connector
     */
    evseType?: 'AC' | 'CCS' | 'CHAdeMO' | 'Type2' | 'oppcharge';
    groupPath?: string | null;
    /**
     * Connector Geo latitude
     */
    lat?: number;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    liquidCoolingSystem?: {
        /**
         * Coolant level sensor error.
         */
        coolantLevelSensorError: boolean;
        /**
         * Status of cable temperatures and contact temperatures.
         */
        dcTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Are fans set to on state.
         */
        fansOn: boolean;
        /**
         * Status of LC system housing temperature.
         */
        housingTempStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Status of leakage detection.
         */
        leakageDetectionStatus?: 'Error' | 'Init' | 'LeakageDetected' | 'Triggered' | 'WaitingForTrigger';
        /**
         * Status of leakage sensor.
         */
        leakageSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Overall status of liquid cooled system.
         */
        overallStatus: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * Is lc connector pluggedin.
         */
        pluggedInDetectionStatus?: {
            /**
             * Status of connector latch
             */
            PPSignalLatchStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * Connector plugin status
             */
            PPSignalPlugStatus?: 'Disabled' | 'Off' | 'On' | 'Unknown';
            /**
             * PP signal status.
             * PP-Signal state describes, if the HPC is plugged into a car‘s inlet and if the latch (HPC Type 1) is pressed
             */
            PPSignalStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        };
        /**
         * Are pumps set to on state.
         */
        pumpOn: boolean;
        /**
         * Status of shock sensor.
         */
        shockSensorStatus?: 'Critical' | 'Disabled' | 'Error' | 'Invalid' | 'Ok' | 'Unknown' | 'Warning';
        /**
         * System info of liquid cooled system.
         */
        systemInfo: {
            /**
             * Hardware version LC system.
             */
            HWVer?: string;
            /**
             * Software version LC system.
             */
            SWVer?: string;
            /**
             * Type of the liquid cooled cable. For example: 'phoenix-liquid-cooled-cable'
             */
            type: string;
        };
        /**
         * Current values of temperature sensors.
         */
        temperatures: {
            /**
             * Temperature of the lc satellite housing.
             */
            housingTemp?: number;
            /**
             * Negative DC cable temperature.
             */
            negCableTemp?: number;
            /**
             * Negative DC Contact temperature.
             */
            negContactTemp: number;
            /**
             * Positive DC cable temperature.
             */
            posCableTemp?: number;
            /**
             * Positive DC Contact temperature.
             */
            posContactTemp: number;
        };
        /**
         * Timestamp of when the status was updated.
         */
        timestamp: string;
    } | null;
    /**
     * Connector Geo longitude
     */
    lng?: number;
    /**
     * Location this EVSE lies in
     */
    locationUid?: string;
    /**
     * Max connector cable current, e.g. 100 or 125 A
     */
    maxCableCurrent?: number;
    /**
     * Maximum power in kilowatts that this connector could output
     */
    maxPowerKw?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed
     */
    maxPowerKwWithoutDynamicLimit?: number;
    /**
     * Maximum power in kilowatts that this connector could output if grid limit was not imposed (unrounded figure)
     */
    maxPowerKwWithoutDynamicLimitActual?: number;
    /**
     * Maximum power in kilowatts that this connector could output (unrounded figure)
     */
    maxPowerkWActual?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics)
     */
    maxPowerkWPresent?: number;
    /**
     * Maximum power in kilowatts, effectively, that this connector can output for new sessions (with regards to the current charger usage with dynamics) (unrounded figure)
     */
    maxPowerkWPresentActual?: number;
    /**
     * Maximum voltage this EVSE can output (500 or 800V)
     */
    maxVoltage?: number;
    /**
     * Reason for why the status is unavailable
     */
    reason?: string;
    schema: 'status';
    schemaVersion?: number;
    /**
     * Station unique identifier.
     */
    stationId: string;
    /**
     * Status of the EVSE or Charging station.
     */
    status: 'Available' | 'Charging' | 'Faulted' | 'Occupied' | 'Operative' | 'Reserved' | 'Unavailable' | 'Unknown';
    /**
     * When status became active.
     * e.g. 2019-04-10T06:10:23.234Z
     */
    statusDate: string;
    tariffIds?: string[] | null;
    tenantIdCPO: string;
    tenantIdEMSP: string;
    tenantIdMaintenance: string;
    /**
     * Which tenants has access to this row
     */
    tenantIds: string[];
    versionCreatedTenantId: string;
    versionCreatedTimestamp: string;
    versionCreatedUserId: string;
    versionCreatedUserRole: string;
    versionDeletedTimestamp?: string;
    versionDeletedUserId: string;
    versionModifiedTimestamp: string;
    versionModifiedUserId: string;
}

export interface SystemMetrics {
    additionalMetrics?: {
        pmcChargingCount?: number;
        pmcCount?: number;
    };
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    metrics: SatelliteMetrics;
    /**
     * Satellite id in which these were measured, or 0 for the cabinet
     */
    satelliteId: number;
    /**
     * Station unique identifier.
     */
    stationId: string;
    /**
     * When the metrics were recorded.
     */
    timestamp: string;
    type: 'CABINET' | 'SATELLITE' | 'SLAVE_CABINET' | 'STANDALONE' | 'TROLLEY' | 'LOADMANAGER';
}

export interface SystemMetricsRow {
    _gsi1pk: string;
    _gsi1sk: string;
    _gsi2pk: string;
    _gsi2sk: string;
    _gsiTenantCPOPk: string;
    _gsiTenantCPOSk: string;
    _gsiTenantEMSPPk: string;
    _gsiTenantEMSPSk: string;
    _gsiTenantMaintenancePk: string;
    _gsiTenantMaintenanceSk: string;
    _pk: string;
    _sk: string;
    /**
     * DynamoDB TTL (Time to Live) - item expiry time (unix timestamp).
     * Set for scheduled deletion of item row.
     * Please note this is SECONDS (unix timestamp) not MILLISECONDS (like usually in javascript).
     */
    _ttl?: number;
    additionalMetrics?: {
        pmcChargingCount?: number;
        pmcCount?: number;
    };
    deleted?: boolean;
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    metrics: SatelliteMetrics;
    /**
     * Satellite id in which these were measured, or 0 for the cabinet
     */
    satelliteId: number;
    schema: 'systemMetrics';
    schemaVersion?: number;
    /**
     * Station unique identifier.
     */
    stationId: string;
    tenantIdCPO: string;
    tenantIdEMSP: string;
    tenantIdMaintenance: string;
    /**
     * Which tenants has access to this row
     */
    tenantIds: string[];
    /**
     * When the metrics were recorded.
     */
    timestamp: string;
    type: 'CABINET' | 'SATELLITE' | 'SLAVE_CABINET' | 'STANDALONE' | 'TROLLEY' | 'LOADMANAGER';
    versionCreatedTenantId: string;
    versionCreatedTimestamp: string;
    versionCreatedUserId: string;
    versionCreatedUserRole: string;
    versionDeletedTimestamp?: string;
    versionDeletedUserId: string;
    versionModifiedTimestamp: string;
    versionModifiedUserId: string;
}

export interface SystemStructure {
    groupPath?: string | null;
    /**
     * licenseId to enforce permissions on this charger
     */
    licenseId?: string | null;
    /**
     * tenantId which provides / pays for the license
     */
    licenseTenantId?: string | null;
    /**
     * Station unique identifier.
     */
    stationId: string;
    structure: any;
    /**
     * When the structure were recorded.
     */
    timestamp: string;
}

export type TransactionStatus =
    | 'Alarm'
    | 'AuthorizedNotPluggedIn'
    | 'Charging'
    | 'Ended'
    | 'InsulationTest'
    | 'PluggedInIdle'
    | 'Unknown';

export interface TxInfo {
    authorizationToken?: string;
    chargedEnergyKwh?: number;
    chargingEndReason?: string;
    chargingEndTime?: string;
    chargingStartReason?: string;
    chargingStartTime?: string;
    connectorId?: string;
    connectorName?: string;
    connectorType?: EVSEType;
    endReason?: string;
    endTime?: string;
    energyLimitKwh?: number;
    powerKw?: number;
    powerKwAvg?: number;
    powerKwMax?: number;
    powerLimitation?: 'Charger' | 'Grid' | 'Queue' | 'Shared' | 'Vehicle';
    schedulePlan?: TxSchedulePlanInfo;
    soc?: number;
    socInitial?: number;
    socLimit?: number;
    startReason?: string;
    startTime?: string;
    status?: TransactionStatus;
    timeLimitMs?: number;
    triggerReason: string;
    txId?: string;
    updateTime: string;
}

/**
 * Information about a scheduled charging in relation to this transaction
 */
export interface TxSchedulePlanInfo {
    /**
     * Vehicle id, if known
     */
    evId?: string;
    /**
     * Schedule's stimated time of arrival ISO timestamp
     */
    plannedArrivalTime?: string;
    /**
     * Schedule's planned departure time ISO timestamp
     */
    plannedDepartureTime?: string;
    /**
     * Scheduled power usage (kW) for this transaction
     */
    powerkW: number;
    /**
     * How long this level of power usage is valid until, as determined by schedule
     */
    powerkWValidUntil: string;
    /**
     * Reference to the EvSchedule row (depot master schedule) which is being utilized, if any
     */
    scheduleId?: string;
    /**
     * Schedule's targeted battery state of charge %
     */
    targetSoC?: number;
    /**
     * Date and time when this information was last updated
     */
    updatedAt: string;
}

export interface OcpiPickOnlineStatusRow {
    'charger-ocpp'?: PickOnlineStatusRow;
    chargeye?: PickOnlineStatusRow;
    ocpi?: PickOnlineStatusRow;
    ocppbridge20?: PickOnlineStatusRow;
}
